/* NZS collection filters — client-side, category-aware faceted filtering + grid density.
   Reads config from #nzs-filter-config and per-card data-* (incl. data-ing = custom.filter_facets.ing).
   Registers Alpine.data('nzsFilters'). No dependency on the native facets.js engine. */
(function () {
  /* NZS-SORT-SERVER (Blake 2026-08-04): the four sorts Shopify can express natively.
     Emitting these as ?sort_by= lets the SERVER order the entire collection, which is
     what the old private ?sort= never did - it reordered only the cards already in the
     DOM, i.e. the current 36-product page. pps-asc / srv-desc have no Shopify
     equivalent and stay client-side over the fully-loaded set. */
  var NZS_SHOPIFY_SORT = {
    'featured': '', 'price-asc': 'price-ascending',
    'price-desc': 'price-descending', 'title-asc': 'title-ascending'
  };
  var NZS_SORT_FROM_SHOPIFY = {
    'price-ascending': 'price-asc', 'price-descending': 'price-desc',
    'title-ascending': 'title-asc', 'manual': 'featured'
  };
  function readConfig() {
    try { return JSON.parse(document.getElementById('nzs-filter-config').textContent); }
    catch (e) { console.warn('[nzs-filters] config parse failed', e); return null; }
  }
  function niceCeil(v, step) { step = step || 1; return Math.ceil(v / step) * step; }
  function num(v) { v = parseFloat(v); return isFinite(v) ? v : null; }
  function validManifest(m) {
    var nums = ['n','price_max','pps_max','srv_max','grams_max'], objs = ['ing_max','toggles','tags','flavour','avail','cat'];
    return !!(m && m.v === 1 && nums.every(function (k) { return typeof m[k] === 'number' && isFinite(m[k]); }) &&
      objs.every(function (k) { return m[k] && typeof m[k] === 'object' && !Array.isArray(m[k]); }));
  }

  function nzsFilters() {
    return {
      cfg: null,
      manifest: null,
      shopAll: false,
      cat: '',
      catList: [],
      subcats: [],          // [{handle,label,count}] — sub-categories present in THIS collection (filter chips)
      subcatMeta: [],       // raw {handle,label} list from #nzs-subcats (counts derived per-page)
      subcatSel: [],        // selected sub-category handles (OR within, AND with the rest)
      catGroup: [],         // NZS-BRANDCAT: top-level categories present (brand/benefit/misc pages) -> "Category" selector
      catSel: [],           // selected top-level category keys (OR within, AND with the rest)
      cards: [],            // [{el, cat, price, onsale, srv, pps, grams, instock, tags:[], ing:{}, fams:[], title}]
      order: [],            // original DOM order (card els) for 'featured'
      sliders: [],          // active slider objects (price, pps, srv, grams, ...ingredients)
      groups: [],           // [{ns,label,options:[{slug,label,count}], sel:[], open}]
      flavour: null,        // {label, options:[{key,label,count}], sel:[], open}
      toggles: [],          // [{key,label,on}]
      availabilityOn: false, // dedicated "In stock only" control, rendered after Price
      availabilityCounts: { in: 0, out: 0 },
      testedOn: false,       // NZS-TFS: "Tested for Sport" toggle (any cert:* tag); hidden on the tested-for-sport collection
      testedCount: 0,
      _isTfs: false,
      sorts: [],
      sort: 'featured',
      density: 'small',
      count: 0,
      total: 0,
      ready: false,
      baseParams: null,
      isSearch: false,
      drawerOpen: false,
      _filterOverlay: null,
      _filterFallbackClose: null,
      _filterEnhance: null,
      /* NZS-SPD-0808: hardcoded false. 'list' density was retired (init downgrades it to 'small'),
         and Lane L strips the dead md:list-layout:* tokens from the card, so nothing can ever
         want a truthy value here. */
      listLayout: false,
      _t: null,
      _slUrl: null,            // NZS-SPD-0927-B3-SLURL: the href a slider input would have replaceState'd, until replayed
      _slReissue: null,        // NZS-SPD-0927-B3-SLURL: key of a traversal cancelled to flush, re-issued unless superseded
      // --- infinite-scroll render window (Blake 2026-06-28) ---
      shown: 0,
      _winBusy: false,
      _cols: 0,
      _matchingCount: 0,
      _io: null,
      sentinel: null,
      loaderEl: null,
      _rt: null,
      _loadingMore: false,
      _allPagesLoaded: false,
      _collectionPage: 0,
      _collectionPages: 0,
      _pageAbort: null,
      _pageSeq: 0,
      _searchWasUntyped: false,
      _loadError: false,
      _loadErrorTimer: null,
      _swapping: false,        // NZS-SORT3-0806: a server-sort swap is in flight (old cards dimmed)
      _staleCards: null,       // NZS-SORT3-0806: the dimmed old card nodes awaiting dropStale()
      _swapPrevSort: null,     // NZS-SORT3-0806: sort key to restore if the swap fetch fails
      // --- NZS-PAGE-0806 (Blake 2026-08-06): per-page loading. ?view=nzs-page&page=N returns 36
      // FULL cards, the same numbering as the SSR ?page=N. _loadedPages tracks which pages are in
      // the DOM, _scrollNext is the sentinel's forward cursor, _seen dedups by product id. ---
      _loadedPages: null,
      _scrollNext: 0,
      _seen: null,
      _hq: null,               // rAF hydration queue (Alpine.initTree + skeleton clears, ~8 cards/frame)
      _hqRunning: false,
      srvPage: 1,              // the ?page cursor the URL carries
      // --- NZS-PGN3-0807 (Blake): bounded pages + Products/page selector. cpPage is the bounded
      // page cursor (mirrors the server page until the client pager takes over); perPage 0 = the
      // server size (36). _tookOver flips once the selector / client pager owns navigation and
      // stays on until reload, so the by-idx window and the real ?page links can never fight. ---
      perPage: 0,
      cpPage: 1,
      ppOptions: [24, 48, 96],
      pagingSize: 0, pagingPage: 0, pagingError: '',
      _paging: null, _pagingScroll: null, _pagingAnchor: '', 
      _tookOver: false,
      _fillDone: null,         // one-shot callback when the in-flight fill settles (client-sort swap)
      _clientSwap: false,      // a client-sort swap is greying the grid
      _transportSb: null,      // the ?sort_by the loaded pages were fetched under ('' = featured)
      _windowShort: false,     // the current bounded page is missing cards it should be showing
      _foreignSb: null,        // an unmapped ?sort_by the SSR slice was rendered under (kept alive in the URL)
      // --- NZS-PGN4-0807 ---
      _transportView: 'nzs-cards',  // lean fetch view; one-shot fallback to 'nzs-page' if absent
      _sortHealed: false,           // the order assertion re-passes at most once per sort
      _cascT: null,                 // cascade cleanup timer
      /* --- NZS-SPD-0808 record store (collections only; /search keeps the DOM engine) ---
         Every known card is a RECORD {pid, idx, facets…, html, el}. The DOM holds only the
         current bounded window; everything else lives as an outerHTML string. */
      /* NZS-SPD-0808h: COMPAT TOMBSTONE — do not delete. The rail pill's SSR markup bound
         `(_loadingMore && !_warming)` until 0808h, and CDN-cached copies of that HTML keep binding
         it for days. With the property gone, Alpine throws `_warming is not defined` DURING the
         initial tree walk, which aborts binding and leaves this.grid unset — the engine then
         renders into the void on every affected landing (live incident 2026-08-08). */
      _warming: false,
      _recByPid: null,         // pid -> record (dedup + O(1) lookup)
      _ordered: null,          // records in current display order (applySort's output)
      _winSig: null,           // pid signature of the FULLY materialised window (no-op guard)
      _matSig: null,           // NZS-SPD-0808b: signature of the window currently being built
      _matPending: false,      // NZS-SPD-0808b: a chunked materialise pass is mid-flight
      _matTok: 0,              // NZS-SPD-0808b: supersede token — a newer pass cancels older chunks
      _staleRecs: null,        // records parked by a keepOld reset (restored if the swap fails)
      _staleIx: null,
      _staleSb: null,          // NZS-SPD-0808b: the transport ledger parked with those records
      _keepCp: 0,              // resetCollection: keep this bounded page instead of snapping to 1
      _tpl: null,              // reusable inert <template> for string -> node
      _cacheP: undefined,      // caches.open() promise (null = unavailable)
      // --- NZS-SPD-0808 twin fast path (pristine $/serve + servings sorts) ---
      _twins: null,            // {pps:{gen,count}, srv:{gen,count}} from data-nzs-twins
      _twinBase: 'shop-all',   // the collection the twins mirror
      _twinDead: false,        // a validation failure this session: never use the twins again
      _twinPages: 0,
      _twinSeen: null,         // NZS-SPD-0808c: pids taken from twin pages under the LIVE transport
      _srvTotal: 0,            // NZS-SPD-0808c: the SSR base collection total (twin freshness ref)
      _tpQueued: false,        // NZS-SPD-0808e: a transport transition is scheduled for end-of-task
      _tpAttempts: 0,          // NZS-SPD-0808f: transition attempts before settling on the client sort
      _adopting: false,        // NZS-SPD-0808g: a grid re-adoption is in progress (re-entry guard)
      _gridMo: null,           // NZS-SPD-0808g: observer that notices a replaced grid element
      /* NZS-SPD-0808i: THESE TWO MUST STAY DECLARED. `this` inside an Alpine component is not the
         component's data object — it is mergeProxies([scope, magics, ...el._x_dataStack]). Its set
         trap writes to the first object in that list that ALREADY OWNS the key, and when nobody
         owns it, to the LAST one: the OUTERMOST ancestor scope. The theme ships
         <body x-data="{ runDispatch: true }">, so an undeclared `this.grid = …` in init() silently
         created `grid` on the BODY component instead of this one (proved live 2026-08-08:
         document.body._x_dataStack[0].grid === the collection grid, while
         hasOwnProperty(_x_dataStack[0],'grid') === false). Reads still resolved through the merge
         proxy, so the engine ran — but the reference lived in a scope shared by every Alpine
         component on the page, and every diagnostic that inspects _x_dataStack[0] saw `grid`
         undefined (that artifact is what the 0808g "the grid element is being replaced" theory was
         actually measuring). Declaring the key makes the set trap land it on this component. */
      grid: null,              // NZS-SPD-0808i: the [data-nzs-grid] element (assigned in init)
      _sobMo: null,            // NZS-SPD-0808i: sold-out-badge relocation observer (same leak)

      /* NZS-SPD-0808b: the ' list-layout' append is dead — density 'list' is downgraded to
         'small' in init and listLayout is hardcoded false (C2 SEV3-F). */
      get gridClass() { return 'nzs-density-' + this.density; },
      get brandCat() { return !this.shopAll && !this.cat; },  // brand/benefit/misc page -> two-level Category selector
      get showTested() { return !this._isTfs && this.testedCount > 0; }, // NZS-TFS
      // --- NZS-PGN3: bounded paging model ---
      get effPerPage() { return this.perPage || 36; },
      /* The real server pager (?page links) owns navigation only in the pristine server state:
         default size, no filter, no client sort, and the client pager never took over. */
      get useServerPager() { return !this.isSearch && this.perPage === 0 && !this._clientOwns() && !this._tookOver; },
      get cpPages() {
        var m = this.anyActive() ? this._matchingCount : this.total;
        return Math.max(1, Math.ceil((m || 0) / this.effPerPage));
      },
      get cpPageList() {  // numbered pager model (n=0 -> ellipsis)
        var t = this.cpPages, c = this.cpPage, out = [], i;
        if (t <= 7) { for (i = 1; i <= t; i++) out.push({ k: 'p' + i, n: i }); return out; }
        out.push({ k: 'p1', n: 1 });
        if (c > 3) out.push({ k: 'e1', n: 0 });
        for (i = Math.max(2, c - 1); i <= Math.min(t - 1, c + 1); i++) out.push({ k: 'p' + i, n: i });
        if (c < t - 2) out.push({ k: 'e2', n: 0 });
        out.push({ k: 'p' + t, n: t });
        return out;
      },

      init() {
        this.cfg = readConfig();
        if (!this.cfg) return;
        var root = this.$root, currentUrl = new URL(location.href);
        var facetIndex = root.querySelector('#nzs-facet-index');
        if (facetIndex) {
          try { var manifest = JSON.parse(facetIndex.textContent); this.manifest = validManifest(manifest) ? manifest : null; }
          catch (e) { console.warn('[nzs-filters] facet manifest parse failed', e); }
        }
        this.baseParams = new URLSearchParams(currentUrl.search);
        this.isSearch = root.dataset.nzsSearch === 'true';
        this._searchWasUntyped = this.isSearch && this.baseParams.get('type') !== 'product';
        if (this.isSearch) this.baseParams.set('type', 'product');
        this.cat = (root.dataset.activeCat || '').trim();
        // shopAll = the true all-products / cross-category pages only (shop-all, tested-for-sport).
        // Brand / benefit / misc pages have an empty cat but are NOT shopAll -> "plain mode"
        // (price/tags/flavour/availability/sort; no ingredient sliders, no category-picker, no Goal).
        this.shopAll = root.dataset.shopAll === 'true';
        this._isTfs = root.dataset.nzsTfs === 'true';   // NZS-TFS: hide the toggle where it is redundant
        this._readTwins();   /* NZS-SPD-0808: data-nzs-twins (absent on every other collection) */
        if (!this.isSearch) this._cacheSweep();   /* NZS-SPD-0808b: retire buckets from older builds */
        var catHandle = { preworkout: 'pre-workout', protein: 'protein', creatine: 'creatine', amino: 'amino-bcaa', massgainer: 'mass-gainers', electrolyte: 'electrolytes', fatburner: 'weight-management', health: 'health-wellness' };
        this.catList = Object.keys(this.cfg.categories).filter(function (k) { return k !== 'other'; })
          .map(function (k) { return { key: k, label: this.cfg.categories[k].label, handle: catHandle[k] || k }; }.bind(this));
        try { this.subcatMeta = JSON.parse(document.getElementById('nzs-subcats').textContent) || []; } catch (e) { this.subcatMeta = []; }
        this.grid = root.querySelector('[data-nzs-grid]');
        if (!this.isSearch && this.grid) {
          this._collectionPage = parseInt(this.grid.dataset.nzsCurrentPage || '1', 10);
          this._collectionPages = parseInt(this.grid.dataset.nzsPages || '0', 10);
          /* NZS-SPD-0808c (Sol 2): the BASE collection's own count, exactly as the server rendered
             it this request — the freshness reference the twins are validated against. Kept
             separate from this.total, which Math.max's in cards.length and can drift upward. */
          this._srvTotal = parseInt(this.grid.dataset.nzsTotal || '', 10) || 0;
          this._allPagesLoaded = this._collectionPages <= 1;
          /* NZS-PAGE-0806: the SSR slice IS its page — a deep ?page=N landing keeps its slice
             and only ever loads forward. No more rewind-to-product-1. */
          this._loadedPages = {};
          this._loadedPages[this._collectionPage] = true;
          this._scrollNext = this._collectionPage + 1;
          this.cpPage = this._collectionPage;   /* NZS-PGN3: bounded cursor starts on the SSR page */
        }
        this.collectCards();
        if (!this.isSearch) {
          this._seen = {};
          this.cards.forEach(function (c) { if (c.pid) this._seen[c.pid] = true; }.bind(this));
        }
        this.density = localStorage.getItem('nzs-density3') || 'small'; if (this.density === 'list') this.density = 'small';
        /* NZS-PGN3: read the selectable sizes from the rendered select (before hydrateFromUrl
           validates ?pp) so a Liquid options edit can never silently no-op in setPerPage. */
        var ppSel = root.querySelector('.nzs-ppp__sel');
        if (ppSel && ppSel.options && ppSel.options.length) {
          var ppOpts = [];
          Array.prototype.forEach.call(ppSel.options, function (o) { var v = parseInt(o.value, 10); if (isFinite(v)) ppOpts.push(v); });
          if (ppOpts.length) this.ppOptions = ppOpts;
        }
        if (!this.isSearch && root.querySelector('.nzs-ppp')) {
          this.perPage = 24; this._tookOver = true;
          this.cpPage = Math.floor((this._collectionPage - 1) * 36 / 24) + 1;
        }
        this.buildControls();
        this.hydrateFromUrl();
        this.ready = true;
        this.$nextTick(function () {
          /* NZS-PAGE-0806: a deep ?page=N landing keeps its SSR slice (it IS page N, full cards)
             and the sentinel loads forward from N+1. A filter/client-sort in the URL chunk-fills
             every missing page (head pages land in place via data-nzs-idx ordering). */
          /* NZS-PGN3: landing with a client sort in the URL — grey the featured-ordered SSR
             cards until the full set is in and ranked (same UX as picking the sort by hand). */
          /* NZS-SPD-0808: a pristine ?sort=pps-asc / srv-desc landing takes the twin instead —
             the SSR slice is base-ordered, so it swaps exactly like a ?sort_by landing would. */
          if (!this.isSearch && this._twinActive()) this._twinEnter(false, null, true);   /* landing: keep ?cp */
          else if (!this.isSearch && !this._serverSortable()) this._swapClient(null);
          else if (this._needsFullSet()) this.filterIntent();
          this.apply(false);
          /* SEV2-D: a pp/cp landing needs its window's transport pages fetched */
          if (!this.isSearch && !this._clientOwns() && this._tookOver) this.ensureWindow();
          if (!this.isSearch && this.grid) this.hydrateQueue(this.grid.querySelectorAll('[data-nzs-card]'));
        }.bind(this));
        var _rawSb = this.baseParams.get('sort_by');
        if (!this.isSearch && _rawSb && !NZS_SORT_FROM_SHOPIFY[_rawSb]) {
          this._foreignSb = _rawSb;                       /* SEV3-B: foreign server order */
          this._transportSb = 'foreign:' + _rawSb;        /* never equals any fetchable transport */
        } else {
          this._transportSb = this._sortByParam() || '';  /* NZS-PGN3: SSR slice's server order */
        }
        this.setupScroll();
        this.initFilterDrawer();
        // NZS-PAGE-0806: the numbered server pager is VISIBLE again — plain hrefs, real
        // navigations; pgnSync keeps them honest with live filter/sort state.
        this.$nextTick(function () { this.pgnSync(); }.bind(this));
        if (this.isSearch) {
          var self = this;
          window.addEventListener('popstate', function () { self.abortLoad(); location.reload(); });
        }
        var selfPh = this;
        if (!this.isSearch) window.addEventListener('popstate', function () {
          selfPh.beginPaging(0, 1); selfPh.perPage = 24; selfPh.cpPage = 1;
          selfPh.hydrateFromUrl(); selfPh.pagingPage = selfPh.cpPage;
          selfPh.ensureWindow(); selfPh.apply(false);
        });
        window.addEventListener('pagehide', function () { selfPh.abortLoad(); }, { once: true });
        window.addEventListener('pagehide', function () { selfPh._slUrlFlush(); });   /* NZS-SPD-0927-B3-SLURL: best effort when leaving mid-drag (see _slUrlNav) */
        if (window.navigation) window.navigation.addEventListener('navigate', function (e) { selfPh._slUrlNav(e); });   /* NZS-SPD-0927-B3-SLURL */
        document.addEventListener('change', function (e) { var el = e.target; if (el && el.classList && el.classList.contains('nzs-range__in')) selfPh._slUrlFlush(); });   /* NZS-SPD-0927-B3-SLURL: thumb released */
      },

      /* ---------- collection page loading: one page for scroll, every missing page for filter/sort ---------- */
      initFilterDrawer() {
        var self = this;
        this._filterFallbackClose = function () { self.drawerOpen = false; };
        window.__nzsSurfaces = window.__nzsSurfaces || {};
        window.__nzsSurfaces.filter = this._filterFallbackClose;
        this.enhanceFilterDrawer();
        if (!this._filterOverlay) {
          this._filterEnhance = function () { self.enhanceFilterDrawer(); };
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._filterEnhance, { once: true });
          window.addEventListener('load', this._filterEnhance, { once: true });
        }
      },
      enhanceFilterDrawer() {
        if (this._filterOverlay || !window.nzsOverlay || typeof window.nzsOverlay.enhance !== 'function') return;
        var root = this.$root.querySelector('[data-nzs-filter-dialog]');
        var trigger = this.$root.querySelector('[data-nzs-filter-trigger]');
        if (!root || !trigger) return;
        var self = this, wasOpen = this.drawerOpen;
        this._filterOverlay = window.nzsOverlay.enhance({
          root: root,
          trigger: trigger,
          key: 'filter',
          label: 'Filters',
          onOpen: function () { self.drawerOpen = true; },
          onClose: function () { self.drawerOpen = false; }
        });
        if (wasOpen) {
          this.drawerOpen = false;
          this._filterOverlay.open();
        }
      },
      openFilterDrawer() {
        this.enhanceFilterDrawer();
        if (this._filterOverlay) { this._filterOverlay.open(); return; }
        if (window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('filter');
        this.drawerOpen = true;
      },
      closeFilterDrawer() {
        this.enhanceFilterDrawer();
        if (this._filterOverlay) { this._filterOverlay.close(); return; }
        this.drawerOpen = false;
      },
      openFilters() { this.openFilterDrawer(); this.filterIntent(); },
      filterIntent() {
        if (this.isSearch) { if (!this._allPagesLoaded && !this._loadingMore) this.loadSearchPages(); return; }
        /* NZS-SPD-0808c (Sol 1b — CONFIRMED, and worse than reported): clearing the LAST filter
           while sorted $/serve re-arms the twin, but nothing re-entered the twin transport. The
           `_allPagesLoaded` return below fired first, then applySort set _ordered = this.order —
           the BASE idx order — and applyPageWindow windowed by base idx. The grid silently showed
           FEATURED order under a "$/serve" sort label. Any time the order becomes SERVER-owned
           while the loaded pages belong to a different transport, re-enter that transport.
           Deliberately NOT fired for client-owned states: a filtered view re-ranks and windows
           ordinally, so twin-sourced records are perfectly valid there and refetching would be
           21 pointless requests. */
        /* NZS-SPD-0808e: DEFERRED, not inline. Running the transition here — on apply()'s stack,
           before apply() has finished mutating cpPage/hidden/_ordered/the URL — is what produced
           all three live failure states: the reset's tail re-entered filterIntent (overflow), then
           a guard flag suppressed the reset's own fetch scheduling (featured order), then the
           post-hoc ensureWindow() hit the _loadingMore/_allPagesLoaded guards and did nothing
           (stale window). Schedule it and let the current pass unwind first. */
        if (this._needTransport()) { this._scheduleTransport(); return; }
        if (this._allPagesLoaded || this._loadingMore) return;
        /* NZS-PAGE-0806/PGN3: only chunk-fill the WHOLE collection when a full set is
           required (a client-only sort, or any active filter). A plain browse is bounded —
           ensureWindow() fetches just the pages the current bounded page overlaps. */
        if (this._needsFullSet()) this.fillAllPages();
      },
      abortLoad() {
        this._paging = null; this.pagingSize = 0; this.pagingPage = 0;
        if (this._pagingScroll != null) { document.documentElement.style.overflowAnchor = this._pagingAnchor; this._pagingScroll = null; }
        if (this._pageAbort) this._pageAbort.abort();
        this._pageAbort = null;
        this._pageSeq++;
        this._loadingMore = false;
        /* NZS-PGN3: a superseded fill must not strand a client-sort swap — the aborted fill's
           finish() never runs (seq mismatch), so clear the swap here; the superseding flow
           (resetCollection keepOld re-dim, or a fresh _swapClient) owns the grid from now on. */
        if (this._clientSwap) this._dimGrid(false);
        this._clientSwap = false;
        this._fillDone = null;
      },
      /* NZS-PAGE-0806 (Blake 2026-08-06): stubs are gone. One transport — ?view=nzs-page&page=N —
         returns 36 FULL nzs-card-lite cards with the same page numbering as the SSR ?page=N, so
         scroll-appends, filter fills and deep landings all compose (dedup by pid, order by
         data-nzs-idx). The old path parsed up to 21.6MB of ?view=nzs-full HTML and patched 776
         innerHTMLs — the #1 renderer lock. Now: network ≤3 requests deep, parse and append
         strictly serial with a rAF yield between pages, so the main thread never blocks. */
      /* NZS-SPD-0808: fetchPage resolves the raw page HTML ({html, cached}) — parsing happens one
         page per _yield tick in step(), so 21 pages are never 21 parses in one task. Cache API
         read-through in front of the network (10 min TTL, versioned bucket). */
      fetchPage(n, controller, attempt, tw) {
        var self = this;
        /* NZS-SPD-0808c: the caller's transport wins. fillPages pins one key for the whole fill so
           a mid-flight intent change cannot make page 7 arrive from a different collection than
           page 1. Undefined = derive it (direct callers / recursion). */
        if (tw === undefined) tw = this._twinActive();
        /* built from the bare pathname: filter params are client-side only, and carrying them
           would fragment the CDN cache key per filter combination for identical server output */
        var path = this._transportPath(tw);
        var url = new URL(path, location.origin);
        url.searchParams.set('view', this._transportView || 'nzs-page');
        url.searchParams.set('page', n);
        var sb = tw ? '' : this._sortByParam();
        if (sb) url.searchParams.set('sort_by', sb);
        this._transportSb = tw ? ('twin:' + tw) : (sb || '');   /* NZS-PGN3: pages are homogeneous — resets clear them on sort swaps */
        var req = this._cacheReq(n, this._transportSb, path);
        var gen = (tw && this._twins && this._twins[tw]) ? this._twins[tw].gen : '';
        return this._cacheGet(req, gen)
          .then(function (hit) {
            if (hit != null) return { html: hit, cached: true };
            return fetch(url.href, { headers: { 'X-Requested-With': 'fetch' }, signal: controller.signal })
              .then(function (r) {
                if (!r.ok) {
                  /* NZS-SPD-0808b: the 404-means-"lean view missing" heuristic is only valid for
                     the BASE collection. A 404 on a twin means the twin collection itself is gone
                     (unpublished / not yet created) — downgrading _transportView there would kill
                     the lean transport for the whole session over an unrelated fault. */
                  if (!tw && r.status === 404 && self._transportView === 'nzs-cards') { var ef = new Error('nzs-cards view missing'); ef.viewFallback = true; throw ef; }
                  var e = new Error('Collection page fetch failed: ' + r.status); e.retryable = r.status === 429 || r.status >= 500; throw e;
                }
                return r.text();
              })
              .then(function (html) {
                if (self._transportView === 'nzs-cards' && html.indexOf('data-nzs-lean') < 0) {
                  /* NZS-PGN4: Shopify serves the DEFAULT template for an unknown ?view (200 +
                     cards), so absence of the lean stamp — not emptiness or a 404 — is the
                     reliable "lean view not live on this theme copy" signal. The stamp is a
                     literal attribute only nzs-cards-transport emits, so a string test is exact
                     and costs no parse. Fall back to the proven transport once. */
                  self._transportView = 'nzs-page';
                  return self.fetchPage(n, controller, attempt, tw);
                }
                if (html.indexOf('data-nzs-grid') < 0) { var ee = new Error('Collection page ' + n + ' returned no grid'); ee.retryable = true; throw ee; }
                self._cachePut(req, html, n);
                return { html: html, cached: false };
              });
          })
          .catch(function (e) {
            if (!tw && e.viewFallback) { self._transportView = 'nzs-page'; return self.fetchPage(n, controller, attempt, tw); }
            if (e.name === 'AbortError' || attempt || !e.retryable) {
              /* NZS-SPD-0808b: ANY unrecoverable twin fetch rejection (404, network, timeout,
                 no-grid) retires the twins for the session and hands the sort back to the client
                 path. An AbortError is our own supersede — never a twin fault. */
              if (tw && e.name !== 'AbortError') self._twinFail(tw, 'fetch: ' + (e.message || e.name));
              throw e;
            }
            return new Promise(function (res) { setTimeout(res, 400 + Math.floor(Math.random() * 401)); })
              .then(function () {
                if (controller.signal.aborted) throw e;
                return self.fetchPage(n, controller, 1, tw);
              });
          });
      },
      /* Parse ONE fetched page into records via an inert <template>: no document, no scripts, no
         image loads, and no clone-into-the-document second build. The elements die with the template — only the
         record (facets + outerHTML string) is kept.
         [] recs = a legitimately empty page (e.g. a gift-placeholder-only tail) — counts as loaded. */
      _pageRecords(html) {
        var t = document.createElement('template');
        t.innerHTML = html;
        var gridEl = t.content.querySelector('[data-nzs-grid]');
        if (!gridEl) return null;
        var out = {
          recs: [],
          gen: gridEl.getAttribute('data-nzs-gen') || '',
          total: parseInt(gridEl.getAttribute('data-nzs-total') || '', 10) || 0,
          pages: parseInt(gridEl.getAttribute('data-nzs-pages') || '', 10) || 0,
          dup: false,
          nopid: false
        };
        var kids = gridEl.querySelectorAll('[data-nzs-card]'), seen = {}, i, el, rec;
        for (i = 0; i < kids.length; i++) {
          el = kids[i];
          rec = this._cardRec(el);
          rec.html = el.outerHTML;
          el._nzs = null;
          rec.el = null;
          /* NZS-SPD-0808b: a card with NO pid is unusable but harmless — skip it. Only a REPEATED
             pid means the ordering is corrupt, and only that may invalidate a twin. */
          if (!rec.pid) { out.nopid = true; continue; }
          if (seen[rec.pid]) { out.dup = true; continue; }
          seen[rec.pid] = true;
          out.recs.push(rec);
        }
        return out;
      },
      /* NZS-SPD-0808: register a fetched page's RECORDS. Nothing enters the DOM here — order is a
         property of the record list (idx), not of insertion, and applyPageWindow materialises
         whatever the current bounded window resolves to. Dedup by pid, pre-resolve the filter
         verdict so a chunked fill can never flash a non-matching card. */
      appendPage(n, recs) {
        if (!this.grid || !recs) return;
        var self = this, added = 0;
        if (!this._seen) this._seen = {};
        if (!this._loadedPages) this._loadedPages = {};
        var filtered = this.ready && this.anyActive();
        recs.forEach(function (rec) {
          if (!rec.pid || self._seen[rec.pid]) return;
          self._seen[rec.pid] = true;
          rec.hidden = filtered ? !self.matches(rec) : false;
          if (self._addRec(rec)) added++;
        });
        this._loadedPages[n] = true;
        if (!added) return;
        this.order = this.cards.slice().sort(function (a, b) { return a.idx - b.idx; });
        /* Mid-fill the display order is the server's (idx). A client sort ranks the FULL set once
           in its done(), behind the dim — exactly as before.
           NZS-SPD-0808b: `[]` is TRUTHY — after a keepOld reset _ordered is an empty array, so the
           old `!this._ordered` test never re-seeded it and every landing page windowed an empty
           list for the whole refill (blank grid, spinner, frozen count). Test the LENGTH. */
        if (!this._ordered || !this._ordered.length || this._serverOwned() || this.sort === 'featured' || this._clientSwap) this._ordered = this.order;
        this.applyPageWindow();   /* NZS-PGN3 (F1): fresh cards land already windowed */
      },
      /* The per-card RECORD. Everything matches()/applySort() need lives here, so a record is
         complete without its element — NZS-SPD-0808 keeps only the window in the DOM.
         `el` is the live node while materialised (null once evicted); `html` is the card's
         outerHTML (captured at parse time, or harvested lazily from an SSR card on eviction). */
      _cardRec(el) {
        if (el._nzs) return el._nzs;
        var ing = {};
        try { ing = JSON.parse(el.dataset.ing || '{}') || {}; } catch (e) { ing = {}; }
        var tags = (el.dataset.tags || '').split('|').filter(Boolean);
        var c = {
          el: el,
          pid: el.getAttribute('data-pid') || '',
          idx: parseInt(el.getAttribute('data-nzs-idx') || '0', 10) || 0,
          html: null,
          live: null,           // NZS-SPD-0808c: retained live element for a user-dirty card
          hidden: false,
          st: null,             // transient per-PID UI state carried across evict/rematerialise
          cat: el.dataset.cat || 'other',
          price: num(el.dataset.price),
          onsale: el.dataset.onsale === 'true',
          srv: num(el.dataset.srv),
          pps: num(el.dataset.pps),
          grams: num(el.dataset.grams),
          cal: num(el.dataset.cal),
          instock: el.dataset.instock !== 'false',
          title: (el.dataset.title || '').toLowerCase(),
          tags: tags,
          subcats: (el.dataset.subcats || '').split('|').filter(Boolean),
          ing: ing,
          fams: []
        };
        c.fams = this.familiesOf(tags);
        el._nzs = c;
        return c;
      },

      /* ---------- NZS-SPD-0808g: the grid reference is never trusted ----------
         Verified live: after the clear-filter transition `st.grid !== document.querySelector(
         '[data-nzs-grid]')` — the engine was rendering correctly into a DETACHED node while the
         document showed a different grid. Something outside this engine replaces that element
         (see reports/E.md round 6 for the two suspects I eliminated). Whoever it is, every write
         path now re-resolves first, so a replacement costs one re-adoption instead of a dead grid. */
      /* Tolerating a detached grid is not enough: the replacement can land AFTER the engine has
         finished its last render, and then nothing would ever look again (live: the transition had
         already converged; the document kept the pre-clear slice forever). One observer on the
         section root, doing ONE boolean test per mutation batch — not per node, which is what made
         the old sold-out badge observer expensive. */
      _watchGrid() {
        if (this.isSearch || this._gridMo || !this.$root || typeof MutationObserver !== 'function') return;
        var self = this;
        try {
          this._gridMo = new MutationObserver(function () {
            if (self._adopting) return;
            if (self.grid && self.grid.isConnected === false) self._liveGrid();
          });
          this._gridMo.observe(this.$root, { childList: true, subtree: true });
        } catch (e) {}
      },
      _liveGrid() {
        var g = this.grid;
        if (!g || g.isConnected !== false) return g;          /* attached, or a host without isConnected */
        var fresh = this.$root ? this.$root.querySelector('[data-nzs-grid]') : null;
        if (!fresh || fresh === g || this._adopting) return g;
        this._adoptGrid(fresh);
        return this.grid;
      },
      /* Cheapest correct re-adoption: the RECORD STORE is untouched by a DOM swap — only the
         element pointers died with the old tree. Harvest what those elements still owe us, point
         at the new grid, re-link to whatever the replacement rendered, rebuild the window. No
         refetch: _loadedPages/_seen remain valid. */
      _adoptGrid(fresh) {
        this._adopting = true;
        try {
          console.warn('[nzs] grid re-adopted');
          var i, r;
          for (i = 0; i < this.cards.length; i++) {
            r = this.cards[i];
            if (r.live) { r.live = null; }        /* a retained live card died with the old tree */
            if (r.el) this._evict(r);             /* harvests html first, so nothing is lost */
          }
          this.grid = fresh;
          this._winSig = null; this._matSig = null; this._matPending = false; this._matTok++;
          if (this.cards.length) {
            /* The replacement rendered SOMEBODY's slice — most likely a server render of a URL
               that no longer describes our state, and always in an idx space that may not be
               ours. Harvesting it would mix two idx spaces in one store (measured: a 36-card
               window became 71). The store is authoritative: drop the foreign cards and let
               applyPageWindow re-render the window we actually own. */
            var kids = fresh.querySelectorAll('[data-nzs-card]'), k;
            for (k = 0; k < kids.length; k++) if (kids[k].parentNode) kids[k].parentNode.removeChild(kids[k]);
          } else {
            this.collectCards();                  /* empty store: the replacement's cards are all we have */
          }
        } catch (e) { console.warn('[nzs] grid re-adopt failed', e); }
        this._adopting = false;
        this.applyPageWindow();
      },

      /* ---------- NZS-SPD-0808: the record store + window materialiser ---------- */
      _recIndex() { if (!this._recByPid) this._recByPid = {}; return this._recByPid; },
      _addRec(rec) {
        var ix = this._recIndex();
        if (!rec.pid || ix[rec.pid]) return false;
        ix[rec.pid] = rec;
        this.cards.push(rec);
        return true;
      },
      /* is there a card in the grid the store has never seen? (SSR slice on init, fail-open
         render, or anything a third-party script injected) — the ONLY reason to re-scan the DOM */
      _unstoredCard() {
        var ix = this._recIndex(), kids = this.grid.querySelectorAll('[data-nzs-card][data-pid]:not([data-nzs-stale])');
        for (var i = 0; i < kids.length; i++) { if (!ix[kids[i].getAttribute('data-pid')]) return true; }
        return false;
      },
      /* rebuild the derived views (idx order + pid index) from this.cards */
      _reindex() {
        var ix = {}, i;
        for (i = 0; i < this.cards.length; i++) { if (this.cards[i].pid) ix[this.cards[i].pid] = this.cards[i]; }
        this._recByPid = ix;
        this.order = this.cards.slice().sort(function (a, b) { return a.idx - b.idx; });
      },
      /* transient state that must survive an evict/rematerialise round trip */
      _captureState(el) {
        return el.querySelector('.nzs-cci.is-open') ? { cci: true } : null;
      },
      _restoreState(el, st) {
        if (!st || !st.cci) return;
        var c = el.querySelector('.nzs-cci');
        if (!c) return;
        c.classList.add('is-open');
        var b = c.querySelector('.nzs-cci__sum');
        if (b) b.setAttribute('aria-expanded', 'true');
      },
      /* NZS-SPD-0808c (Sol 5): has the shopper changed a widget on this card away from what the
         server rendered? A rebuild-from-HTML would silently revert it. Compares live DOM state to
         the parser's defaults, so it is exact and needs no bookkeeping. */
      _isDirty(el) {
        var i, n, sels = el.querySelectorAll('select');
        for (i = 0; i < sels.length; i++) {
          var opts = sels[i].options, def = -1;
          for (n = 0; n < opts.length; n++) { if (opts[n].defaultSelected) { def = n; break; } }
          if (def < 0) def = 0;
          if (sels[i].selectedIndex !== def) return true;
        }
        var ins = el.querySelectorAll('input[type="radio"],input[type="checkbox"]');
        for (i = 0; i < ins.length; i++) { if (ins[i].checked !== ins[i].defaultChecked) return true; }
        return false;
      },
      /* Alpine's own MutationObserver destroys any subtree removed from the document, so keeping a
         live element only works if Alpine never sees the removal. mutateDom() is the public escape
         hatch it uses for exactly this (x-if/x-for move nodes the same way). Without it we cannot
         retain reactivity, so we fall back to the rebuild path. */
      _quietDom(fn) {
        var A = window.Alpine;
        if (A && typeof A.mutateDom === 'function') { try { A.mutateDom(fn); return true; } catch (e) {} }
        return false;
      },
      /* Take a card out of the DOM. SSR cards have no html yet — harvest it here (once), stripped
         of app-injected badges and transient classes so a rematerialised card is byte-equivalent
         to a freshly fetched one. */
      _evict(rec) {
        var el = rec.el;
        if (!el) return;
        /* NZS-SPD-0808c (Sol 5): a card the shopper has interacted with keeps its LIVE element —
           detached, un-destroyed, fully reactive — and is reattached verbatim. Bounded to
           interacted cards; everything else still collapses to a string. */
        if (this._isDirty(el) && this._quietDom(function () { if (el.parentNode) el.parentNode.removeChild(el); })) {
          rec.live = el;
          rec.el = null;
          return;
        }
        if (rec.html == null) {
          var cl = el.cloneNode(true);
          cl.classList.remove('nzs-hidden', 'nzs-offpage', 'nzs-card--in');
          cl.removeAttribute('data-nzs-needinit');
          /* labels-and-badges.js injects .x-badge-container client-side; the app re-injects on
             the next reveal, so carrying a copy would stack duplicates. */
          Array.prototype.forEach.call(cl.querySelectorAll('.x-badge-container'), function (b) { if (b.parentNode) b.parentNode.removeChild(b); });
          /* transient UI state is carried by rec.st, never baked into the html, so a later
             close/open is always the one that wins */
          Array.prototype.forEach.call(cl.querySelectorAll('.nzs-cci.is-open'), function (c) {
            c.classList.remove('is-open');
            var b2 = c.querySelector('.nzs-cci__sum'); if (b2) b2.setAttribute('aria-expanded', 'false');
          });
          /* NZS-LAZYX-0907: a card evicted before it woke would bake x-ignore into rec.html, and
             the rebuilt node is not the one the activator's IO observed -- dead card forever. */
          Array.prototype.forEach.call(cl.querySelectorAll('[data-nzs-lazyx]'), function (z) {
            z.removeAttribute('x-ignore'); z.removeAttribute('data-nzs-lazyx');
          });
          rec.html = cl.outerHTML;
        }
        rec.st = this._captureState(el);
        try { if (window.Alpine && window.Alpine.destroyTree) window.Alpine.destroyTree(el); } catch (e) {}
        if (el.parentNode) el.parentNode.removeChild(el);
        el._nzs = null;   /* break the record<->element cycle so the node can be collected */
        rec.el = null;
      },
      /* string -> live node, via ONE reusable inert <template>. insertBefore adopts the node, so
         there is no clone step and no second tree build. */
      _buildEl(rec) {
        /* NZS-SPD-0808c (Sol 5): a retained live element is reattached as-is — still initialised,
           still reactive, still carrying the shopper's variant pick. No needinit: re-running
           initTree on a tree that was never destroyed would double-bind it. */
        if (rec.live) {
          var lv = rec.live;
          rec.live = null;
          rec.el = lv;
          lv.classList.toggle('nzs-hidden', !!rec.hidden);
          lv.classList.remove('nzs-offpage');
          return lv;
        }
        if (!rec.html) return null;
        var t = this._tpl || (this._tpl = document.createElement('template'));
        t.innerHTML = rec.html;
        var el = t.content.firstElementChild;
        if (!el) return null;
        el.setAttribute('data-nzs-needinit', '');
        el.classList.toggle('nzs-hidden', !!rec.hidden);
        el.classList.remove('nzs-offpage');
        this._restoreState(el, rec.st);
        el._nzs = rec;
        rec.el = el;
        return el;
      },
      /* Render `list` (records, in display order) as the grid's ENTIRE contents and evict the
         rest. Minimal-move reconcile: an unchanged window costs nothing, a page turn costs one
         insert per card. Hydration is synchronous, in the same task as the insert, so Alpine has
         resolved x-cloak/x-show before the frame paints. */
      _materialize(list) {
        var grid = this._liveGrid(), self = this;   /* NZS-SPD-0808g: never write into a detached grid */
        if (!grid) return;
        if (this._swapping) return;   /* a keepOld swap owns the grid until dropStale() */
        /* NZS-SPD-0808f: the signature carries the ORDERING IDENTITY, not just the pid sequence.
           Same 36 pids can be the right answer for one (sort, filter, transport, page) state and
           the wrong one for the next; a pid-only signature let a stale window pass as current
           across an ownership flip. Cheap to build, and it makes the no-op guard provably safe. */
        var i, keep = {};
        var sig = this.sort + '|' + (this.anyActive() ? 1 : 0) + '|' + this._transportKey() + '|' +
                  (this._serverOrdered() ? 's' : 'c') + '|' + this.cpPage + '|' + this.effPerPage + '|';
        for (i = 0; i < list.length; i++) { sig += list[i].pid + ','; keep[list[i].pid] = 1; }
        if (sig === this._winSig && !this._matPending) return;        /* already fully rendered */
        if (sig === this._matSig && this._matPending) return;         /* already being rendered */
        /* NZS-SPD-0808b: a pass in flight is superseded, not raced — _winSig only becomes truthy
           when the LAST chunk lands, so a half-built window can never be mistaken for a done one. */
        this._matSig = sig;
        this._winSig = null;
        this._matPending = true;
        var tok = ++this._matTok;
        var kids = Array.prototype.slice.call(grid.querySelectorAll('[data-nzs-card]')), held = {};
        for (i = 0; i < kids.length; i++) {
          var pid = kids[i].getAttribute('data-pid');
          var r = pid ? this._recIndex()[pid] : null;
          if (r && keep[pid] && !held[pid]) { held[pid] = 1; r.el = kids[i]; continue; }
          if (r && r.el === kids[i]) this._evict(r);                                  /* known card: harvest + destroy */
          else if (kids[i].parentNode) kids[i].parentNode.removeChild(kids[i]);       /* orphan / duplicate node */
        }
        /* Build in chunks of 24: the FIRST chunk runs synchronously so the above-the-fold rows
           paint in this task (no x-cloak flash), the rest ride _yield so a 72-card page turn — or
           the 761-card fail-open render — never owns one long task. */
        var ref = grid.firstElementChild, at = 0;
        function chunk() {
          if (tok !== self._matTok) return;   /* superseded by a newer window */
          var fresh = [], n = 0, rec, el, wasLive;
          for (; at < list.length && n < 24; at++, n++) {
            rec = list[at];
            el = rec.el;
            wasLive = !el && !!rec.live;   /* NZS-SPD-0808c (Sol 5): retained, still-initialised card */
            if (!el) { el = self._buildEl(rec); if (!el) continue; if (!wasLive) fresh.push(el); }
            if (ref === el) { ref = ref.nextElementSibling; continue; }
            /* a retained card must go back in without Alpine noticing, or its observer will
               initTree an already-live subtree and double-bind every directive on the card */
            if (wasLive) {
              (function (e2, r2) { if (!self._quietDom(function () { grid.insertBefore(e2, r2); })) grid.insertBefore(e2, r2); })(el, ref);
            } else {
              grid.insertBefore(el, ref);
            }
          }
          if (fresh.length) self._hydrateEls(fresh);
          if (at < list.length) { self._yield(chunk); return; }
          self._matPending = false;
          self._winSig = sig;
          if (self._pagingScroll != null) {
            window.scrollTo({top:self._pagingScroll,behavior:'instant'});
            document.documentElement.style.overflowAnchor = self._pagingAnchor; self._pagingScroll = null;
          }
        }
        chunk();
      },
      /* NZS-SPD-0808: the collection reveal is Alpine init ONLY. Image reveal is the card's own
         inline onload (nzs-card-lite.liquid) plus the nzs-base.css 2s keyframe backstop — one
         mechanism, not three. revealCards() keeps its image loop for /search, which forces
         eager loading inside its scroll-reveal window. */
      _hydrateEls(els) {
        for (var i = 0; i < els.length; i++) {
          var card = els[i];
          if (!card.hasAttribute || !card.hasAttribute('data-nzs-needinit')) continue;
          card.removeAttribute('data-nzs-needinit');
          try { if (window.Alpine && window.Alpine.initTree) window.Alpine.initTree(card); }
          catch (e) { console.warn('[nzs] card hydrate failed', e); }
        }
      },
      /* hydrate appended/SSR cards a few per frame — Alpine.initTree + skeleton clears via
         revealCards, spread over rAF so a 36-card append never owns a whole frame and the
         visible rows (queued first, DOM order) hydrate first. */
      /* NZS-PGN5-0807: rAF-paced loops STALL COMPLETELY in hidden tabs (Chrome suspends rAF) —
         a shopper tabbing away mid-sort froze the fill until the watchdog killed the swap and
         rolled the sort back ("only works after refresh", Blake). Race rAF against a short
         timer: visible tabs keep frame pacing; hidden tabs tick on (clamped) timers and the
         work still lands. */
      _yield(fn) {
        var done = false, run = function () { if (!done) { done = true; fn(); } };
        (window.requestAnimationFrame || setTimeout)(run);
        setTimeout(run, 120);
      },
      hydrateQueue(els) {
        if (!els || !els.length) return;
        /* NZS-SPD-0808: a collection batch is now the bounded window (≤72) and must be live
           before the next paint — one synchronous pass, no rAF queue. The queue mechanics below
           stay for /search, whose batches are unbounded. */
        if (!this.isSearch) { this._hydrateEls(els); return; }
        var self = this;
        this._hq = (this._hq || []).concat(Array.prototype.slice.call(els));
        if (this._hqRunning) return;
        this._hqRunning = true;
        (function step() {
          var batch = self._hq.splice(0, document.hidden ? 32 : 8);
          if (batch.length) self.revealCards(batch, false);   /* no eager-forcing: native lazy owns collection images */
          if (self._hq.length) self._yield(step);
          else self._hqRunning = false;
        })();
      },
      /* Filter/client-sort path: chunk-fill every missing page behind the rail pill. Network ≤3
         requests in flight; parse+append strictly serial in page order with a rAF yield between
         pages — the grid grows visibly and the main thread never locks. */
      fillAllPages() {
        if (this.isSearch || !this.grid || this._allPagesLoaded || this._loadingMore) return;
        /* NZS-SPD-0808: a FILTER can flip the transport too (twin -> base), not just a sort —
           so the homogeneity guard belongs here, not only in ensureWindow/_swapClient. */
        if (this._transportGuard()) return;
        var missing = [], p, pt = this._pagesTotal();
        for (p = 1; p <= pt; p++) if (!this._loadedPages || !this._loadedPages[p]) missing.push(p);
        this.fillPages(missing);
      },
      /* NZS-PGN3: make sure the transport pages covering the current bounded window are in.
         Client-owned sets need everything (full-set ranking + exact counts); a plain browse at
         any page size needs only the pages its window overlaps (<=3 fetches at 72/page). */
      ensureWindow() {
        if (this.isSearch || !this._liveGrid()) return;   /* NZS-SPD-0808g */
        if (this._clientOwns()) { this.filterIntent(); return; }
        if (this._allPagesLoaded || this._loadingMore) return;
        /* SEV1-A: pages loaded under a different transport get thrown away (keepOld reset,
           which restarts the fetch itself) before fetching in the current order. */
        if (this._transportGuard()) return;
        var eff = this.effPerPage, pt = this._pagesTotal() || 1;
        var startIdx = (this.cpPage - 1) * eff + 1;
        var endIdx = Math.min(this.cpPage * eff, pt * 36);
        if (this.cpPage >= this.cpPages) endIdx = pt * 36;   /* idx holes: the last page runs to the end */
        var pgLo = Math.max(1, Math.ceil(startIdx / 36));
        var pgHi = Math.max(pgLo, Math.min(pt, Math.ceil(endIdx / 36)));
        var missing = [], p;
        for (p = pgLo; p <= pgHi; p++) if (!this._loadedPages || !this._loadedPages[p]) missing.push(p);
        if (missing.length) this.fillPages(missing);
      },
      /* ---------- NZS-SPD-0808e: transport transitions ----------
         Two separate questions, previously (and wrongly) answered by one flag:
           _transportFresh() — do the records in the store come from the transport the CURRENT
             sort implies? This governs DISPLAY, and it must never depend on a fetch succeeding.
           _needTransport()  — should we go and fetch the right transport? This governs LOADING.
         Keeping them apart is what makes the failure mode safe: while the twin pages are being
         fetched (or if they never arrive), the grid still shows a correct CLIENT ranking of the
         records it has, instead of the server idx order of a transport that no longer applies. */
      _transportFresh() { return this._transportSb == null || this._transportSb === this._transportKey(); },
      /* the display order is the server's ONLY when the loaded pages actually came from it */
      _serverOrdered() { return this._serverOwned() && this._transportFresh(); },
      _needTransport() {
        return !this.isSearch && !this._loadingMore && this._serverOwned() &&
          this._transportSb != null && this._transportSb !== this._transportKey() &&
          !!(this._loadedPages && Object.keys(this._loadedPages).length);
      },
      /* Run the transition on a CLEAN stack, one at a time. _yield is the codebase's
         "after this task, and still alive in a hidden tab" primitive.
         Recursion is now impossible by construction rather than by flag: resetCollection() sets
         _transportSb = null before its tail runs, and _needTransport() requires _transportSb to be
         non-null, so nothing the reset calls can re-enter this path. */
      _scheduleTransport() {
        if (this._tpQueued) return;
        this._tpQueued = true;
        var self = this;
        this._yield(function () {
          self._tpQueued = false;
          if (!self._needTransport()) { self._tpAttempts = 0; self.applyPageWindow(); return; }
          self._tpAttempts = (self._tpAttempts || 0) + 1;
          var tw = self._twinActive();
          if (tw) self._twinEnter(false, null, false);
          else self.resetCollection(false, true, null);
          /* If the transition did not even start a fetch there is no finish() coming to settle
             it, so settle on the next tick instead of leaving the engine "needing" a transport
             forever (live: _needTransport() stayed true indefinitely). */
          if (!self._loadingMore) self._yield(function () { self._settleTransport(); });
        });
      },
      /* NZS-SPD-0808f: the convergence guarantee. Called after every transition attempt that did
         not start a fill, and at the end of every fill. The engine must never sit permanently
         mid-transition: either the ledger now matches, or we try once more, or we stop asking. */
      _settleTransport() {
        if (this.isSearch) return;
        /* a keepOld swap whose fill will never finish (superseded/aborted before any page landed)
           would otherwise leave _swapping true forever — and _materialize refuses to touch the
           grid while it is, which is a frozen window with no way back */
        if (this._swapping && !this._loadingMore) this.dropStale(true);
        if (this._loadingMore) return;                       /* a fill is running; its finish() settles */
        if (!this._needTransport()) { this._tpAttempts = 0; return; }
        if ((this._tpAttempts || 0) < 2) { this._scheduleTransport(); return; }
        /* Two honest attempts and the ledger still disagrees — the transport is unreachable
           (twins unpublished, 404, repeated validation failure, a fetch that never lands). Stop
           claiming we need it: retiring the twins makes the sort client-owned, which the record
           store already ranks correctly over the full set. Convergent, and the shopper sees a
           correct $/serve order rather than a permanent half-transition. */
        this._tpAttempts = 0;
        if (this._twinActive()) {
          this._twinDead = true;
          console.warn('[nzs] twin transport unreachable after 2 attempts — settling on the client sort');
        }
        this.applySort();
        this.applyPageWindow();
      },
      /* NZS-SPD-0808c: a fill discovered mid-flight that the shopper's intent changed transports.
         Stop it, then re-enter through the normal doors — both begin with _transportGuard(), which
         sees the still-stamped old _transportSb and performs the keepOld reset + refetch. */
      _restartForTransport() {
        this.abortLoad();
        if (this._needsFullSet()) this.fillAllPages(); else this.ensureWindow();
      },
      /* NZS-SPD-0808: ONE definition of "the pages currently in the grid were fetched under a
         different transport". Base pages and twin pages carry the same product set in different
         orders, so mixing them duplicates and drops products — always reset first. */
      _transportGuard() {
        if (this._transportSb != null && this._transportSb !== this._transportKey() &&
            this._loadedPages && Object.keys(this._loadedPages).length) {
          this.resetCollection(false, true, null);
          return true;
        }
        return false;
      },
      fillPages(missing) {
        if (this.isSearch || !this.grid || this._loadingMore) return;
        var self = this, controller = new AbortController(), seq = ++this._pageSeq;
        if (!missing.length) {
          this._allPagesLoaded = true; this.showLoader(false); this.afterLoadMore(true);
          var cb0 = this._fillDone; this._fillDone = null;
          if (cb0) cb0(true);
          return;
        }
        this._pageAbort = controller;
        this._loadingMore = true;
        if (!this._twinSeen) this._twinSeen = {};   /* NZS-SPD-0808c: lives with the transport, cleared by resetCollection */
        /* NZS-SPD-0808c (Sol 1a — CONFIRMED): fillAllPages/ensureWindow return early on
           _loadingMore BEFORE their transport guard, so a filter ticked mid-fill could not start
           a new fill — but pump() runs again after every page, and re-evaluated _twinActive() at
           that later moment. Pages 4..21 then arrived from the BASE collection into a twin-keyed
           store. The fill now OWNS a transport key for its whole life: every page is fetched
           under it, and a resolution that lands after the intent moved is dropped, not merged. */
        var fillKey = this._transportKey(), fillTw = this._twinActive();
        clearTimeout(this._loadErrorTimer);
        this._loadErrorTimer = null;
        this._loadError = false;
        this.showLoader(true);
        var settled = false, failed = false, dropped = false;
        var _wd = function () {
          if (settled || seq !== self._pageSeq) return;
          if (document.hidden) { watchdog = setTimeout(_wd, 15000); return; }   /* NZS-PGN5: hidden tabs run on clamped timers — judge only while visible */
          controller.abort(); finish(false);
        };
        var watchdog = setTimeout(_wd, 30000);
        function finish(complete) {
          if (settled || seq !== self._pageSeq) return;
          settled = true; clearTimeout(watchdog);
          self._pageAbort = null; self._loadingMore = false;
          /* NZS-PGN3: "all loaded" is a recount, not the wrapper's claim — a windowed fetch that
             happens to complete the set flips it too, and a partial fill never lies. */
          var seen = 0, k, _pt = self._pagesTotal();
          for (k in self._loadedPages) seen++;
          if (seen >= _pt) { self._allPagesLoaded = true; self._scrollNext = _pt + 1; }
          if (!complete) {
            self.dropStale(true);
            /* Leave _allPagesLoaded false so the next filter/sort intent retries; pages already
               appended stay (deduped) and only the missing ones refetch. */
            self._loadError = true; clearTimeout(self._loadErrorTimer);
            self._loadErrorTimer = setTimeout(function () { self._loadError = false; self._loadErrorTimer = null; }, 3000);
          }
          self.showLoader(false);
          self.afterLoadMore(true, true);
          var cb = self._fillDone; self._fillDone = null;
          if (cb) cb(complete && self._allPagesLoaded);   /* a re-armed retry lands back in _fillDone */
          /* NZS-PGN3: self-heal — a cpGo/setPerPage that landed while this fetch was in
             flight could not start its own window fetch (the _loadingMore guard); run it now. */
          if (!self._loadError && !self._allPagesLoaded && self._windowShort) self.ensureWindow();
          self._settleTransport();   /* NZS-SPD-0808f: converge or stop asking */
        }
        var inflight = {}, nextFetch = 0, idx = 0;
        function pump() {
          while (nextFetch < missing.length && Object.keys(inflight).length < 10) {   /* PGN4b: origin scales near-linearly with width (measured) */
            (function (pg) {
              /* the fill's OWN transport, not whatever _twinActive() says at this instant */
              inflight[pg] = self.fetchPage(pg, controller, 0, fillTw).catch(function (e) { if (e.name !== 'AbortError') failed = true; return null; });
            })(missing[nextFetch++]);
          }
        }
        function step() {
          if (settled || seq !== self._pageSeq || controller.signal.aborted) return;
          if (idx >= missing.length) { finish(!failed); return; }
          var pg = missing[idx++];
          inflight[pg].then(function (res) {
            if (settled || seq !== self._pageSeq || controller.signal.aborted) return;
            /* NZS-SPD-0808c: intent moved under this fill (a filter tick flipped twin<->base).
               Registering these records would merge two idx spaces — abandon and re-enter. */
            if (self._transportKey() !== fillKey) { self._restartForTransport(); return; }
            delete inflight[pg];
            pump();
            /* NZS-SPD-0808: parse here, one page per _yield tick */
            var parsed = res ? self._pageRecords(res.html) : null;
            if (parsed) {
              var tw = self._twinActive();
              if (tw && !self._twinValid(tw, parsed)) { self._twinFail(tw, 'page ' + pg); return; }
              if (tw) {
                /* NZS-SPD-0808b: record this page's pids for the fill's own dedup ledger */
                if (!self._twinSeen) self._twinSeen = {};
                for (var z = 0; z < parsed.recs.length; z++) self._twinSeen[parsed.recs[z].pid] = 1;
                if (parsed.pages > 0) self._twinPages = parsed.pages;
              }
              if (parsed.recs.length) {
                if (!dropped) { self.dropStale(false); dropped = true; }
                self.appendPage(pg, parsed.recs);
              } else {
                if (!self._loadedPages) self._loadedPages = {};
                self._loadedPages[pg] = true;   /* legitimately empty page — loaded, nothing to add */
              }
            } else if (res) {
              failed = true;   /* 200 with no grid after the retry budget */
            }
            self._yield(step);   /* NZS-PGN5: background-safe pacing */
          });
        }
        pump();
        step();
      },
      /* NZS-SORT2-0805: a sort change clears the grid and reloads it from lot 1 in the new server
         order (the SSR/loaded cards are in the OLD order, so they cannot simply be re-sorted in
         place). Eager when a filter is active (needs the full set), else the first lot + progressive. */
      resetCollection(scrollTop, keepOld, prevSort) {
        if (this.isSearch || !this._liveGrid()) { this.apply(); return; }   /* NZS-SPD-0808g */
        this.abortLoad();
        if (keepOld) {
          /* NZS-SORT3-0806: a user sort change — keep the stale cards on screen, dimmed and
             inert, until the new order's lot 1 is parsed. dropStale() performs the swap, so
             the grid never blanks (measured 1.5s of empty grid per sort before this).
             NZS-SPD-0808: the stale RECORDS are parked too — the store must be empty so the
             incoming transport's records (same pids, new idx) can register, and _materialize
             must leave the parked DOM alone until dropStale() runs. */
          this._swapping = true;
          this._staleCards = Array.prototype.slice.call(this.grid.querySelectorAll('[data-nzs-card]'));
          this._staleCards.forEach(function (n) { n.setAttribute('data-nzs-stale', ''); });
          /* re-entrant swap (e.g. a twin validation failure mid-swap): the DOM on screen is still
             the ORIGINAL stale set, so keep the records that go with it — never park the empty
             store the previous reset just created.
             NZS-SPD-0808b: the transport ledger is part of that snapshot. Restoring records
             without _transportSb left the guard believing the kept base pages were twin pages,
             which then merged two idx spaces silently. */
          if (!this._staleRecs) { this._staleRecs = this.cards; this._staleIx = this._recByPid; this._staleSb = this._transportSb; }
          this.cards = []; this._recByPid = {}; this.order = []; this._ordered = null; this._winSig = null;
          this._swapPrevSort = (prevSort == null ? this.sort : prevSort);
          this._dimGrid(true);
        } else {
          this._swapping = false; this._staleCards = null; this._swapPrevSort = null;
          this._staleRecs = null; this._staleIx = null; this._staleSb = null;   /* NZS-SPD-0808b */
          Array.prototype.forEach.call(this.grid.querySelectorAll('[data-nzs-card]'), function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
          this.cards = []; this.order = []; this._recByPid = {}; this._ordered = null; this._winSig = null;
        }
        this._loadedPages = {}; this._seen = {}; this._scrollNext = 1;   /* NZS-PAGE-0806 */
        this._twinSeen = {};   /* NZS-SPD-0808c (Sol 3): the twin ledger dies with the transport */
        /* NZS-SPD-0808c (Sol 6): cancel any chunked materialise pass — its remaining chunks would
           insert cards from the order we are throwing away, into a grid the reset just re-owned. */
        this._matTok++; this._matPending = false; this._matSig = null;
        this._allPagesLoaded = false; this._loadError = false;
        this.shown = 0; this._matchingCount = 0;
        this.srvPage = 1;   // a fresh order starts at the top
        this.cpPage = this._keepCp || 1;  /* NZS-PGN3; NZS-SPD-0808: a twin landing keeps its ?cp */
        this._keepCp = 0;
        this._transportSb = null;        /* pages cleared — transport unknown until the refetch */
        this._foreignSb = null;          /* D: the refetch re-orders the grid — drop a foreign ?sort_by claim */
        /* NZS-SORT2-0805: clean ?page out of the URL NOW, before the async afterLoadMore ->
           hydrateFromUrl re-reads it and clobbers srvPage back (deep-page landing). Order is
           already correct without this; it just stops ?page lingering + re-fetching on reload. */
        this.writeUrl(true);
        if (!keepOld) this.collectCards();   // grid now empty; keeps count/total honest from data-nzs-total
        this.showLoader(true);
        if (scrollTop) this.scrollGridTop();   // a user-driven sort change: bring the new #1 into view
        if (this._needsFullSet()) this.fillAllPages(); else this.ensureWindow();
      },
      /* NZS-SORT3-0806: end a keepOld swap. keepStale=false — replacement cards are ready:
         remove the dimmed old set in the same synchronous block as the append (one paint).
         keepStale=true — the fetch failed: keep the old grid and restore the old sort key. */
      dropStale(keepStale) {
        if (!this._swapping) return;
        this._swapping = false;
        var stale = this._staleCards || []; this._staleCards = null;
        var staleRecs = this._staleRecs, staleIx = this._staleIx, staleSb = this._staleSb;
        this._staleRecs = null; this._staleIx = null; this._staleSb = null;
        var prev = this._swapPrevSort; this._swapPrevSort = null;
        if (keepStale) {
          if (this._clientSwap) { this._swapPrevSort = prev; }   /* SEV1-B: done() owns the rollback */
          else if (prev && prev !== this.sort) { this.sort = prev; this.writeUrl(true); }
          /* NZS-PAGE-0806: the swap reset zeroed _seen/_loadedPages while these cards stayed on
             screen — re-seed both so a later fill cannot re-append them.
             NZS-SPD-0808: the parked RECORDS are the seed (they cover evicted cards too, which a
             DOM read would miss), and they go straight back into the store. */
          stale.forEach(function (n) { n.removeAttribute('data-nzs-stale'); });
          if (!this.isSearch) {
            if (staleRecs) { this.cards = staleRecs; this._recByPid = staleIx || {}; this._reindex(); this._ordered = null; }
            /* NZS-SPD-0808b: the kept pages belong to the PARKED transport — restore the ledger
               with them or _transportGuard reads the new transport's key against old pages. */
            this._transportSb = (staleSb === undefined ? null : staleSb);
            var seedSeen = {}, seedPages = {}, maxPg = 0;
            this.cards.forEach(function (r) {
              if (r.pid) seedSeen[r.pid] = true;
              if (r.idx > 0) { var pg = Math.ceil(r.idx / 36); seedPages[pg] = true; if (pg > maxPg) maxPg = pg; }   /* 36 = the section's fixed page size */
            });
            this._seen = seedSeen; this._loadedPages = seedPages;
            this._scrollNext = maxPg ? maxPg + 1 : 1;
            this._allPagesLoaded = false;
            this._winSig = null;   /* the kept DOM was not built by _materialize */
          }
        } else {
          stale.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
          if (staleRecs) staleRecs.forEach(function (r) { if (r.el) { r.el._nzs = null; r.el = null; } });
          this._winSig = null;
        }
        if (!this._clientSwap) {   /* E-N1: a client-sort swap owns the dim until its done() */
          this._dimGrid(false);
          if (!keepStale) {
            /* NZS-PGN4: the caller appends the new cards right AFTER this returns — hop one frame
               so the cascade animates the landed window, not an empty grid */
            var _cw = this;
            (window.requestAnimationFrame || setTimeout)(function () { _cw._cascadeWindow(); });
          }
        }
      },
      loadSearchPages() {
        if (!this.grid || this._allPagesLoaded || this._loadingMore) return;
        if (this._pageAbort) this._pageAbort.abort();
        var self = this, controller = new AbortController(), seq = ++this._pageSeq;
        var currentPage = parseInt(this.grid.dataset.nzsCurrentPage || '1', 10);
        var pages = parseInt(this.grid.dataset.nzsPages || '0', 10), seen = {}, pageList = [], buffered = {}, next = 0, failed = false;
        if (!pages) { this._allPagesLoaded = true; return; }
        for (var page = 1; page <= pages; page++) {
          if (page !== currentPage || this._searchWasUntyped) pageList.push(page);
        }
        Array.prototype.forEach.call(this.grid.querySelectorAll('[data-nzs-card][data-pid]'), function (n) { seen[n.getAttribute('data-pid')] = true; });
        this._pageAbort = controller;
        this._loadingMore = true;
        clearTimeout(this._loadErrorTimer);
        this._loadErrorTimer = null;
        this._loadError = false;
        var settled = false, watchdog = setTimeout(function () {
          if (settled || seq !== self._pageSeq) return;
          controller.abort();
          finish(false);
        }, 8000);
        function finish(complete) {
          if (settled || seq !== self._pageSeq) return;
          settled = true;
          clearTimeout(watchdog);
          self._pageAbort = null;
          self._loadingMore = false;
          if (complete) self._allPagesLoaded = true;
          else {
            self._allPagesLoaded = false;
            self._loadError = true;
            clearTimeout(self._loadErrorTimer);
            self._loadErrorTimer = setTimeout(function () { self._loadError = false; self._loadErrorTimer = null; }, 3000);
          }
          self.afterLoadMore(true);
        }
        function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
        function requestPage(requestedPage, attempt) {
          var params = new URLSearchParams(self.baseParams);
          params.set('page', requestedPage);
          params.set('section_id', 'nzs-search-data');
          var url = location.pathname + '?' + params.toString();
          return fetch(url, { headers: { 'X-Requested-With': 'fetch' }, signal: controller.signal })
            .then(function (r) {
              if (!r.ok) {
                var statusError = new Error('Search section fetch failed: ' + r.status);
                statusError.retryable = r.status === 429 || r.status >= 500;
                throw statusError;
              }
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var add = Array.prototype.slice.call(doc.querySelectorAll('[data-nzs-grid] [data-nzs-card]'));
              if (!add.length) {
                var emptyError = new Error('Search section returned no cards for page ' + requestedPage);
                emptyError.retryable = true;
                throw emptyError;
              }
              return add;
            })
            .catch(function (e) {
              if (e.name === 'AbortError' || attempt || !e.retryable) throw e;
              return wait(400 + Math.floor(Math.random() * 401)).then(function () {
                if (seq !== self._pageSeq || controller.signal.aborted) return [];
                return requestPage(requestedPage, 1);
              });
            });
        }
        function worker() {
          if (seq !== self._pageSeq || controller.signal.aborted || next >= pageList.length) return Promise.resolve();
          var requestedPage = pageList[next++];
          return requestPage(requestedPage, 0)
            .then(function (add) { if (add.length) buffered[requestedPage] = add; })
            .catch(function (e) { if (e.name !== 'AbortError') failed = true; })
            .then(worker);
        }
        var workers = [];
        for (var i = 0; i < Math.min(4, pageList.length); i++) workers.push(worker());
        Promise.all(workers).then(function () {
          if (seq !== self._pageSeq || controller.signal.aborted) return;
          pageList.forEach(function (requestedPage) {
            var add = buffered[requestedPage];
            if (!add) return;
            var frag = document.createDocumentFragment();
            add.forEach(function (n) {
              var pid = n.getAttribute('data-pid');
              if (!pid || seen[pid]) return;
              seen[pid] = true;
              /* NZS-SPD-0927-B3-D6 (Tier A): adoptNode moves the parsed element instead of deep-cloning it. The cards hold no
                 custom elements; <template x-if> content is re-homed to this document's template owner either way; <script
                 type="application/json"> blocks never run; inline img onload attributes fire from this document; form
                 controls keep the state a clone copies; the parsed document is discarded. Same tree, attributes, mutation
                 records, same task (real Chrome: src/test_b3_d6.html). */
              frag.appendChild(document.adoptNode(n));
            });
            var fresh = Array.prototype.slice.call(frag.childNodes);
            self.grid.appendChild(frag);
            if (window.Alpine && window.Alpine.initTree) {
              fresh.forEach(function (n) { if (n.nodeType === 1) window.Alpine.initTree(n); });
            }
          });
          finish(!failed);
        });
      },
      afterLoadMore(programmatic, keepWindow) {
        this._slUrlFlush();   /* NZS-SPD-0927-B3-SLURL: buildControls() resets slider lo/hi and hydrateFromUrl() restores them from the URL */
        this._loadingMore = false;
        // Rebuild the rail over the full card set, then restore the user's active filters from the URL.
        this.collectCards();
        this.buildControls();
        this.hydrateFromUrl();
        this.apply(false, keepWindow);   // NZS-SORT2-0805: keepWindow preserves scroll on a progressive lot-load
        if (programmatic) this.writeUrl(true);
      },

      /* ---------- card ingestion ---------- */
      collectCards() {
        /* NZS-SPD-0808: on collections the record store IS the set — a DOM read can only ever
           ADD (the SSR slice on init, or a stale-CDN fail-open render), never replace. That
           retires the whole class of "collectCards read an emptied grid and zeroed this.cards"
           races the guard below was written for. /search keeps the DOM engine verbatim. */
        if (!this.isSearch) {
          var ixc = this._recIndex(), self0 = this, harvested = 0;
          Array.prototype.forEach.call(this.$root.querySelectorAll('[data-nzs-card]:not([data-nzs-stale])'), function (el) {
            var pid = el.getAttribute('data-pid');
            if (!pid) return;
            if (ixc[pid]) { ixc[pid].el = el; el._nzs = ixc[pid]; return; }
            var rec = self0._cardRec(el);
            rec.el = el;
            if (self0._addRec(rec)) harvested++;
          });
          if (harvested) this.order = this.cards.slice().sort(function (a, b) { return a.idx - b.idx; });
          else if (!this.order) this.order = this.cards.slice();
          if (!this._ordered) this._ordered = this.order;
          /* NZS-TRUECOUNT: collections paginate by 36, so cards.length is only the loaded page(s).
             The grid carries the server-side count (data-nzs-total, gift-placeholder already
             excluded); prefer it so the toolbar reads the collection, not the DOM. */
          var _srvT = parseInt((this.grid && this.grid.dataset.nzsTotal) || '', 10);
          this.total = (_srvT > 0 ? Math.max(_srvT, this.cards.length) : this.cards.length);
          return;
        }
        var els = Array.prototype.slice.call(this.$root.querySelectorAll('[data-nzs-card]'));
        /* NZS-SORT2-0805: defensive only — never overwrite a populated set with an empty read. */
        if (!els.length && this.grid && this.grid.querySelector('[data-nzs-card]')) return;
        if (this.isSearch) els.sort(function (a, b) {
          return (parseInt(a.dataset.nzsPage || '1', 10) - parseInt(b.dataset.nzsPage || '1', 10)) ||
            (parseInt(a.dataset.nzsIndex || '0', 10) - parseInt(b.dataset.nzsIndex || '0', 10));
        });
        this.order = els.slice();
        /* NZS-FASTLOAD: bulk pages are appended after whatever page the shopper landed on,
           so DOM arrival order is not the collection's order unless they started on page 1.
           data-nzs-idx is the product's absolute position from the server (page-size
           independent - see sections/nzs-collection.liquid), so 'Featured' restores the
           real thing. Guarded: a cached page rendered before that attribute existed simply
           keeps the old DOM-order behaviour. */
        if (!this.isSearch && els.length && els[0].dataset.nzsIdx) {
          this.order = els.slice().sort(function (a, b) {
            return (parseInt(a.dataset.nzsIdx || '0', 10) - parseInt(b.dataset.nzsIdx || '0', 10));
          });
        }
        /* NZS-PAGE-0806: per-el memo (_cardRec) — afterLoadMore re-collects after every appended
           page, and re-parsing 700+ data-ing JSON blobs each time was measurable jank. */
        this.cards = els.map(function (el) { return this._cardRec(el); }.bind(this));
        /* NZS-TRUECOUNT: collections paginate by 36, so cards.length is only the loaded page(s).
           The grid carries the server-side count (data-nzs-total, gift-placeholder already
           excluded); prefer it so the toolbar reads the collection, not the DOM. */
        var _srv = parseInt((this.grid && this.grid.dataset.nzsTotal) || '', 10);
        this.total = (_srv > 0 ? Math.max(_srv, this.cards.length) : this.cards.length);
      },
      flavourSlugs(tags) {
        var out = [];
        tags.forEach(function (t) { if (t.indexOf('flavour:') === 0) out.push(t.slice(8)); });
        return out;
      },
      familiesOf(tags) {
        if (!this.cfg.flavour) return [];
        var slugs = this.flavourSlugs(tags), fams = this.cfg.flavour.families, out = [];
        Object.keys(fams).forEach(function (fam) {
          var kws = fams[fam];
          for (var i = 0; i < slugs.length; i++) {
            for (var j = 0; j < kws.length; j++) { if ((function (sl, kw) { if (kw.indexOf('-') >= 0) return ('-' + sl + '-').indexOf('-' + kw + '-') >= 0; var sg = sl.split('-'); for (var x = 0; x < sg.length; x++) { var g = sg[x]; if (g === kw || g.slice(0, kw.length) === kw || g.slice(g.length - kw.length) === kw) return true; } return false; })(slugs[i], kws[j])) { out.push(fam); return; } }
          }
        });
        return out;
      },

      /* ---------- build the filter rail from present data ---------- */
      buildControls() {
        var cards = this.cards, manifest = this.manifest, disclosureState = {};
        /* NZS-SORT3-0806: never rebuild the rail from a transiently-empty set (failed lot
           fetch, mid-swap re-entry) — the $0.00–$1.00 empty-rail state Blake screenshotted.
           Freeze the last-good controls instead. First build (ready=false) unaffected. */
        if (this.ready && !cards.length && !manifest) return;
        if (this.ready) {
          (this.groups || []).forEach(function (g) { disclosureState['group:' + g.ns] = { open: g.open, showAll: g.showAll }; });
          if (this.flavour) disclosureState['flavour:' + this.flavour.label] = { open: this.flavour.open };
          (this.sliders || []).forEach(function (s) { if (s.kind === 'ing') disclosureState['slider:' + s.label] = { open: s.open }; });
        }
        /* NZS-TRUECOUNT: the manifest's n is the size of the FACET INDEX, not the collection
           (222 vs a real 244 on /collections/protein), and this line ran after collectCards()
           so it silently won - the toolbar disagreed with the hero on the same page. The
           server total from the grid wins wherever it exists; the manifest stays the fallback
           for surfaces that ship no data-nzs-total (/search). */
        var _srvTotal = parseInt((this.grid && this.grid.dataset.nzsTotal) || '', 10);
        if (!(_srvTotal > 0) && manifest && num(manifest.n) != null) this.total = num(manifest.n);
        // Ingredient sliders + category toggles only exist on a single resolved category page.
        // All-products (shop-all) and brand/benefit/misc pages have no single category -> catCfg null
        // -> no ingredient sliders (per Blake: too many ingredients span the whole catalogue).
        var catCfg = this.cat ? (this.cfg.categories[this.cat] || null) : null;

        // numeric range sliders: price, pps, servings, grams
        var maxPrice = 0, maxPps = 0, maxSrv = 0, maxGrams = 0, hasPps = false, hasSrv = false, hasGrams = false;
        if (manifest) {
          maxPrice = num(manifest.price_max) || 0; maxPps = num(manifest.pps_max) || 0;
          maxSrv = num(manifest.srv_max) || 0; maxGrams = num(manifest.grams_max) || 0;
          hasPps = hasSrv = (num(manifest.n) || 0) > 0; hasGrams = maxGrams > 0;
        } else {
          hasPps = hasSrv = !cards.length;   /* NZS-SORT3-0806: no evidence != evidence of absence — keeps Price/serve + Servings sorts visible while the set is transiently empty */
          cards.forEach(function (c) {
            if (c.price != null) maxPrice = Math.max(maxPrice, c.price);
            if (c.pps != null) { maxPps = Math.max(maxPps, c.pps); hasPps = true; }
            if (c.srv != null) { maxSrv = Math.max(maxSrv, c.srv); hasSrv = true; }
            if (c.grams != null) { maxGrams = Math.max(maxGrams, c.grams); hasGrams = true; }
          });
        }
        // NZS-CAL-SLIDER (Blake 2026-08-04): calories are not in the collection
        // facet_manifest, so the ceiling always comes from the loaded cards - on a
        // paginated collection that is the loaded pages only, same as the ingredient
        // sliders on non-manifest pages.
        var maxCal = 0, hasCal = false;
        cards.forEach(function (c) { if (c.cal != null) { maxCal = Math.max(maxCal, c.cal); hasCal = true; } });
        var sliders = [];
        sliders.push(this.mkSlider('price', 'price', 'Price', '$', 100, 0, niceCeil(maxPrice, 500) || 100, 100));
        if (hasPps && maxPps > 0) sliders.push(this.mkSlider('pps', 'pps', 'Price / serve', '$', 100, 0, niceCeil(maxPps, 25) || 50, 5));
        if (hasSrv && maxSrv > 0) sliders.push(this.mkSlider('srv', 'srv', 'Servings', '', 1, 0, niceCeil(maxSrv, 5) || 30, 1));
        if (hasGrams && maxGrams > 0) sliders.push(this.mkSlider('grams', 'grams', 'Size', 'g', 1, 0, niceCeil(maxGrams, 100) || 500, 50));
        if (hasCal && maxCal > 0) sliders.push(this.mkSlider('cal', 'cal', 'Calories / serve', ' kcal', 1, 0, niceCeil(maxCal, 50) || 300, 10));

        // category ingredient sliders (only those present on >=1 card; single-category pages only)
        ((catCfg && catCfg.ingredients) || []).forEach(function (ing) {
          var present = manifest ? Object.prototype.hasOwnProperty.call(manifest.ing_max || {}, ing.key) :
            cards.some(function (c) { return c.ing && c.ing[ing.key] != null; });
          if (!present) return;
          sliders.push(this.mkSlider('ing', ing.key, ing.label, ing.unit, ing.div, 0, ing.max, ing.step));
        }.bind(this));
        sliders.forEach(function (s) {
          if (s.kind !== 'ing') return;
          var saved = disclosureState['slider:' + s.label];
          if (saved) { s.open = saved.open; s._openRestored = true; }
        });
        this.sliders = sliders;

        // tag checkbox groups (present namespaces only)
        var groups = [];
        (this.cfg.tagGroups || []).forEach(function (g) {
          if (g.shopAllOnly && !this.shopAll) return;  // e.g. Goal: only on the all-products page
          var counts = manifest ? ((manifest.tags && manifest.tags[g.ns]) || {}) : {};
          if (!manifest) {
            cards.forEach(function (c) {
              c.tags.forEach(function (t) {
                if (t.indexOf(g.ns + ':') === 0) { var v = t.slice(g.ns.length + 1); counts[v] = (counts[v] || 0) + 1; }
              });
            });
          }
          var opts = Object.keys(counts).sort().map(function (slug) { return { slug: slug, label: this.titleize(slug), count: counts[slug] }; }.bind(this));
          if (opts.length) {
            var saved = disclosureState['group:' + g.ns];
            groups.push({ ns: g.ns, label: g.label, options: opts, sel: [], open: saved ? saved.open : false, showAll: saved ? saved.showAll : false, _openRestored: !!saved });
          }
        }.bind(this));
        this.groups = groups;

        // sub-category chips: count present members in THIS collection, drop zero, keep #nzs-subcats order
        var subCounts = {};
        cards.forEach(function (c) { c.subcats.forEach(function (h) { subCounts[h] = (subCounts[h] || 0) + 1; }); });
        this.subcats = (this.subcatMeta || []).filter(function (m) { return subCounts[m.handle]; })
          .map(function (m) { return { handle: m.handle, label: m.label, count: subCounts[m.handle] }; });

        // NZS-BRANDCAT: top-level Category selector (brand/benefit/misc pages only — no single resolved cat).
        // Built from each card's data-cat, in config category order, labelled from the config ('other' -> 'Other').
        if (this.brandCat) {
          var catCounts = manifest ? (manifest.cat || {}) : {};
          if (!manifest) cards.forEach(function (c) { catCounts[c.cat] = (catCounts[c.cat] || 0) + 1; });
          var catOrder = Object.keys(this.cfg.categories);
          Object.keys(catCounts).forEach(function (k) { if (catOrder.indexOf(k) < 0) catOrder.push(k); });
          this.catGroup = catOrder.filter(function (k) { return catCounts[k]; }).map(function (k) {
            var label = (k === 'other') ? 'Other' : ((this.cfg.categories[k] && this.cfg.categories[k].label) || this.titleize(k));
            return { key: k, label: label, count: catCounts[k] };
          }.bind(this));
        } else {
          this.catGroup = [];
        }

        // flavour families present
        var famCount = manifest ? (manifest.flavour || {}) : {};
        if (!manifest) cards.forEach(function (c) { c.fams.forEach(function (f) { famCount[f] = (famCount[f] || 0) + 1; }); });
        var famOrder = Object.keys(this.cfg.flavour ? this.cfg.flavour.families : {});
        var famOpts = famOrder.filter(function (f) { return famCount[f]; }).map(function (f) { return { key: f, label: this.titleize(f), count: famCount[f] }; }.bind(this));
        var flavourLabel = this.cfg.flavour ? (this.cfg.flavour.label || 'Flavour') : 'Flavour';
        var flavourSaved = disclosureState['flavour:' + flavourLabel];
        this.flavour = famOpts.length ? { label: flavourLabel, options: famOpts, sel: [], open: flavourSaved ? flavourSaved.open : false, _openRestored: !!flavourSaved } : null;

        // toggles: category toggles (present, single-category pages only) + on_sale (if any) + in_stock
        var toggles = [];
        ((catCfg && catCfg.toggles) || []).forEach(function (k) {
          var def = this.cfg.toggleDefs[k]; if (!def) return;
          var n = manifest ? ((manifest.toggles && manifest.toggles[k]) || 0) :
            this.cards.filter(function (c) { return this.togglePass(c, def); }.bind(this)).length;
          if (n) toggles.push({ key: k, label: def.label, on: false, count: n });
        }.bind(this));
        /* NZS-RRP15-0806: the "On sale" toggle is retired — compare-at now sits above price on
           essentially every product, so the facet matched ~100%% of the grid and meant nothing.
           data-onsale + the c.onsale record stay (cards/labels still read them). */
        this.toggles = toggles;  // in-stock is its own dedicated control (rendered after Price)

        var availCounts = { in: 0, out: 0 };
        if (manifest) {
          availCounts.in = num(manifest.avail && manifest.avail.in) || 0;
          availCounts.out = num(manifest.avail && manifest.avail.out) || 0;
        } else {
          cards.forEach(function (c) { availCounts[c.instock ? 'in' : 'out']++; });
        }
        this.availabilityCounts = availCounts;

        // NZS-TFS: count = cards carrying any cert:* tag (drug-tested certification namespace)
        this.testedCount = cards.filter(function (c) { return c.tags.some(function (t) { return t.indexOf('cert:') === 0; }); }).length;

        // sorts (drop pps/srv sorts if data absent)
        this.sorts = (this.cfg.sorts || []).filter(function (s) {
          if (s.key === 'pps-asc' && !hasPps) return false;
          if (s.key === 'srv-desc' && !hasSrv) return false;
          return true;
        });
      },
      mkSlider(kind, key, label, unit, div, min, max, step) {
        return { id: kind + '-' + key, kind: kind, key: key, label: label, unit: unit, div: div, min: min, max: max, step: step, lo: min, hi: max, open: kind !== 'ing', _openRestored: false };
      },
      /* NZS-SPD-0808: toggleHasMatches() deleted — zero callers in JS, Liquid or /search markup. */
      titleize(s) {
        return (s || '').replace(/[-_]+/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); }).replace(/\bBcaa\b/, 'BCAA').replace(/\bEaa\b/, 'EAA').replace(/\bRtd\b/, 'RTD').replace(/\bNsf\b/, 'NSF');
      },

      /* ---------- matching ---------- */
      sliderActive(s) { return s.lo > s.min || s.hi < s.max; },
      cardValue(c, s) {
        if (s.kind === 'price') return c.price;
        if (s.kind === 'pps') return c.pps;
        if (s.kind === 'srv') return c.srv;
        if (s.kind === 'grams') return c.grams;
        if (s.kind === 'cal') return c.cal;
        if (s.kind === 'ing') return (c.ing && c.ing[s.key] != null) ? c.ing[s.key] : null;
        return null;
      },
      togglePass(c, def) {
        if (def.type === 'tag') return c.tags.indexOf(def.tag) >= 0;
        var v = (c.ing && c.ing[def.key] != null) ? c.ing[def.key] : null;
        if (def.type === 'ing_absent0') return v == null || v === 0;   // e.g. caffeine-free: no caffeine listed, or 0
        if (def.type === 'ing_zero') return v === 0;                   // e.g. sugar-free: an explicit 0 on the panel
        if (def.type === 'ingmax') return v != null && v <= def.max;
        if (def.type === 'ingmin') return v != null && v >= def.min;
        return false;
      },
      matches(c) {
        // category (shop-all with a picked category)
        if (this.shopAll && this.cat && c.cat !== this.cat) return false;
        // top-level Category selector (brand/misc pages; OR within, AND with the rest)
        if (this.catSel.length && this.catSel.indexOf(c.cat) < 0) return false;
        // sub-category chips (OR within, AND with the rest)
        if (this.subcatSel.length && !this.subcatSel.some(function (h) { return c.subcats.indexOf(h) >= 0; })) return false;
        // sliders
        for (var i = 0; i < this.sliders.length; i++) {
          var s = this.sliders[i]; if (!this.sliderActive(s)) continue;
          var v = this.cardValue(c, s);
          /* NZS-PGN3: pps/srv 0 = "no per-serve data on file" (shakers, samples) — an active
             range must exclude them, exactly as the sorts already park them last. */
          if ((s.kind === 'pps' || s.kind === 'srv') && !(v > 0)) return false;
          if (v == null || v < s.lo || v > s.hi) return false;
        }
        // tag groups (AND across groups, OR within)
        for (var g = 0; g < this.groups.length; g++) {
          var grp = this.groups[g]; if (!grp.sel.length) continue;
          var ok = grp.sel.some(function (slug) { return c.tags.indexOf(grp.ns + ':' + slug) >= 0; });
          if (!ok) return false;
        }
        // flavour families
        if (this.flavour && this.flavour.sel.length) {
          var f = this.flavour.sel.some(function (fam) { return c.fams.indexOf(fam) >= 0; });
          if (!f) return false;
        }
        // availability (dedicated "In stock only" control)
        if (this.availabilityOn && !c.instock) return false;
        // NZS-TFS: Tested for Sport toggle — any cert:* tag qualifies
        if (this.testedOn && !c.tags.some(function (t) { return t.indexOf('cert:') === 0; })) return false;
        // toggles
        /* NZS-SPD-0808: the 'on_sale' branch is gone with the retired toggle (NZS-RRP15-0806
           stopped building it, so it could never be in this.toggles). */
        for (var t = 0; t < this.toggles.length; t++) {
          var tg = this.toggles[t]; if (!tg.on) continue;
          var def = this.cfg.toggleDefs[tg.key]; if (def && !this.togglePass(c, def)) return false;
        }
        return true;
      },

      /* ---------- apply + sort ---------- */
      apply(writeUrl, keepWindow) {
        if (!this.ready) return;
        /* NZS-SORT-CLIENT (/search): the bulk loader appends cards asynchronously and several
           paths can collect and sort in different orders; if this.cards falls out of step with
           the grid, applySort() reorders a stale list and the DOM keeps its server order.
           Re-collect when they disagree.
           NZS-SPD-0808 (collections): the store is authoritative and DOM-independent, so the
           only reason to re-scan is a card the store has never seen. */
        if (this.isSearch && this.grid) {
          var _domN = this.grid.querySelectorAll('[data-nzs-card]').length;
          if (_domN && _domN !== this.cards.length) this.collectCards();
        } else if (this.grid && this._unstoredCard()) {
          this.collectCards();   /* NZS-SPD-0808: only ever harvest a card the store has not seen */
        }
        if (writeUrl !== false) this.filterIntent();
        if (writeUrl !== false) { this.srvPage = 1; this.cpPage = 1; }   // a user-driven change restarts the page cursor
        /* NZS-SPD-0927-B3-D2 (Tier A): the /search window's column count, read ONCE and before the verdict loop and the
           sort touch the DOM, then handed to resetWindow/applyWindow (each used to force its own style+layout read after
           the writes). The value cannot differ: the grid's only children are auto-placed span-1 cards, so the resolved
           grid-template-columns is its explicit repeat(N) (nzs-filters.css L133-L142: media query + density class +
           --nzs-cols); nothing in apply() changes the viewport, --nzs-cols or the density class (the :class effect flushes
           in a microtask, after apply), and card classes/order never create or remove tracks. */
        var _wk = this.isSearch ? this.windowConsts() : null;
        var n = 0;
        /* NZS-SPD-0927-B3-D5 (Tier A): on /search the verdict loop calls the SAME matches() with `this` = a snapshot whose
           prototype is the component proxy. The fields matches() reads are own properties holding their raw values
           (Alpine.raw); anything not listed still falls through to the proxy, so a later edit of matches() stays correct.
           Records are iterated raw. matches/sliderActive/cardValue/togglePass only read (strings/numbers compared the same
           raw or proxied), so every verdict, class toggle (same order) and n is identical. What is skipped is Alpine's
           mergeProxies/reactive get+set traps; no binding, watcher or effect reads a record's `hidden` or iterates `cards`
           (the panel templates call anyActive/fmt/pct/min/max only; apply() is only reached from handlers/timers, never
           inside an effect), so the untracked `hidden` write is unobservable. Collections keep the original loop. */
        var _R = this.isSearch && window.Alpine && window.Alpine.raw;
        if (_R) {
          var _st = Object.create(this), _mk = ['shopAll', 'cat', 'catSel', 'subcatSel', 'sliders', 'groups', 'flavour', 'availabilityOn',
            'testedOn', 'toggles', 'cfg', 'matches', 'sliderActive', 'cardValue', 'togglePass'];
          for (var _i = 0; _i < _mk.length; _i++) Object.defineProperty(_st, _mk[_i], { value: _R(this[_mk[_i]]) });
          var _rc = _R(this.cards);
          for (var _j = 0; _j < _rc.length; _j++) {
            var _c = _rc[_j], _ok = _st.matches(_c);
            _c.hidden = !_ok;
            if (_c.el) _c.el.classList.toggle('nzs-hidden', !_ok);
            if (_ok) n++;
          }
        } else this.cards.forEach(function (c) {
          var ok = this.matches(c);
          c.hidden = !ok;                                            /* NZS-SPD-0808: the verdict lives on the record… */
          if (c.el) c.el.classList.toggle('nzs-hidden', !ok);        /* …the class only mirrors it while materialised */
          if (ok) n++;
        }.bind(this));
        /* NZS-TRUECOUNT: the toolbar reads the COLLECTION, not the DOM. Unfiltered it is the
           server's own total (cards.length is only the loaded page). Filtered it is the match
           count, which is exact once the full set is in - ~1s behind the click on the fast
           loader, with the rail's "Loading all results" pill covering the gap. Deliberately
           NOT keyed on sorting: that is what made the number climb 36 -> 244 while a sort
           loaded. */
        /* NZS-SPD-0808: mid-swap the store is deliberately empty (the old records are parked
           until dropStale decides), so freeze the last good count rather than flash the
           "No products match these filters" empty state — same rule buildControls uses. */
        if (!(this._swapping && !this.cards.length)) this.count = this.anyActive() ? n : this.total;
        this.applySort();
        if (this.isSearch) { if (keepWindow) this.applyWindow(_wk); else this.resetWindow(_wk); }   // NZS-SORT2-0805: /search keeps the reveal window (NZS-SPD-0927-B3-D2: _wk)
        else {
          if (!(this._swapping && !this.cards.length)) this._matchingCount = n;   /* NZS-SPD-0808: same mid-swap freeze — the pager must not collapse to 1 page */
          if ((this._allPagesLoaded || !this._clientOwns()) && this.cpPage > this.cpPages) this.cpPage = this.cpPages;   /* G-N1 */
          this.applyPageWindow();   /* NZS-PGN3: bounded pages own visibility on collections */
        }
        if (writeUrl !== false) this.writeUrl();
      },
      applyDebounced() { clearTimeout(this._t); this._t = setTimeout(function () { this.apply(); }.bind(this), 120); },
      /* the one comparator set, shared by /search's DOM sort and the collection record sort */
      _cmp(key) {
        return function (a, b) {
          switch (key) {
            case 'price-asc': return (a.price || 0) - (b.price || 0);
            case 'price-desc': return (b.price || 0) - (a.price || 0);
            // NZS-SORT-CLIENT: 0 means "no price-per-serve on file", not "free" — park it
            // at the end with the nulls instead of letting it head the ascending list.
            case 'pps-asc': return ((a.pps > 0 ? a.pps : 1e12) - (b.pps > 0 ? b.pps : 1e12)) || ((a.price || 0) - (b.price || 0));
            case 'srv-desc': return ((b.srv || 0) - (a.srv || 0)) || ((a.pps > 0 ? a.pps : 1e12) - (b.pps > 0 ? b.pps : 1e12));
            case 'title-asc': return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
          }
          return 0;
        };
      },
      applySort() {
        if (!this.grid) return;
        if (this._clientSwap) return;   /* NZS-PGN3: the swap's done() runs the one final sort */
        if (this.isSearch) {
          /* /search is unchanged: every sort is client-side and the DOM is the model, so the
             matched elements are detached and re-appended in rank order. this.order holds
             ELEMENTS on this path (collections hold records — see collectCards). */
          var key = this.sort, arr;
          if (key === 'featured') { arr = this.order.slice(); }
          else { arr = this.cards.slice().sort(this._cmp(key)).map(function (c) { return c.el; }); }
          /* NZS-SPD-0927-B3-3b: skip the detach + re-append when the grid already ends with exactly this sequence
             (the append would leave the same DOM), e.g. 'featured' after a load that started on page 1. A focused
             card control still gets the re-append, which drops its focus today - kept identical. */
          var kids = this.grid.children, kn = kids.length, k = 0, same = !this.grid.contains(document.activeElement);
          if (same && arr.length) {
            while (k < kn && kids[k] !== arr[0]) k++;
            for (var ai = 0; ai < arr.length; ai++, k++) { if (k >= kn || kids[k] !== arr[ai]) { same = false; break; } }
            if (same && k !== kn) same = false;
          }
          if (!same) {
            var frag = document.createDocumentFragment();
            arr.forEach(function (el) { frag.appendChild(el); });
            this.grid.appendChild(frag);
          }
          return;
        }
        /* NZS-SPD-0808: collections rank RECORDS into _ordered; applyPageWindow materialises the
           window slice in that order. Nothing is detached, so the NZS-SORT2-0805 reorder-racing-
           collectCards bug cannot recur, and a 761-card rank costs one array sort instead of a
           761-node DOM reorder.
           NZS-SORT2-0805: the native sorts (and the twin collections) arrive server-ordered — the
           server's absolute idx IS the rank, so those keys never re-rank here.
           NZS-SPD-0808e: …but ONLY while the records actually came from that transport. Trusting
           _serverOwned() alone is what rendered base/featured idx order under a "$/serve" label
           when the twin had not (or could not) load. When the ledger is stale we rank client-side
           over whatever is in the store — for a full 761-record store that is exactly the right
           answer, and for a partial one it is at least correctly ordered. 'featured' has no
           comparator, so idx remains its only possible order. */
        if (this._serverOrdered() || this.sort === 'featured') { this._ordered = this.order; return; }
        this._ordered = this.cards.slice().sort(this._cmp(this.sort));
      },

      /* NZS-PGN3: bounded page windowing. Server-transport states window by ABSOLUTE position
         (data-nzs-idx), so a deep landing or a 72-size page never depends on head pages being
         loaded. Client-owned states window the MATCHING set ordinally, in rank order. */
      applyPageWindow() {
        if (this.isSearch) return;
        if (!this._liveGrid()) return;   /* NZS-SPD-0808g: re-resolve before any window work */
        /* NZS-SPD-0808f: rendering is NEVER gated on a pending transition. 0808e skipped the
           render while _tpQueued was up, to avoid one frame of the old order — but that made the
           DOM hostage to an async flag: if the queued transition did not run, or did not clear the
           flag, the grid froze on the pre-clear window and even a manual apply() could not repair
           it (live: the filtered subset stayed on screen with a correct _ordered behind it).
           The window we build here is the CLIENT ranking, which is already correct; the transition
           just re-renders it in twin order when it lands. One extra render beats a frozen grid. */
        /* NZS-SPD-0808: the window is a slice of the RECORD list, and _materialize makes the DOM
           equal it. .nzs-offpage is no longer needed to hide anything (off-window cards are not
           in the document at all) — the class stays in the CSS for old cached markup only. */
        /* NZS-SPD-0808b: an empty _ordered array is truthy — fall through to the idx order (or the
           raw store) instead of windowing nothing. Belt to appendPage's re-seed. */
        var recs = (this._ordered && this._ordered.length) ? this._ordered : (this.order || this.cards);
        var i, rec, list = [];
        if (!this.useServerPager && !this.$root.querySelector('[data-nzs-client-pgn]')) {
          /* F5: stale CDN-cached HTML — no client pager in this markup, so a bounded window
             would strand matches past the first page with no way to reach them. Fail OPEN and
             render every match until the page cache rolls. */
          for (i = 0; i < recs.length; i++) if (!recs[i].hidden) list.push(recs[i]);
          this._windowShort = false;
          this._materialize(list);
          this.showLoader(this._loadingMore);
          return;
        }
        var eff = this.effPerPage, shortOf = false;
        /* NZS-SPD-0808e: this was `!this._clientOwns()`, i.e. `_serverOwned() && !anyActive()`.
           The freshness term is the addition: idx windowing is only meaningful while the records
           carry the idx space of the CURRENT transport. Stale ledger -> ordinal windowing over the
           client ranking, which is what applySort just produced. */
        if (this._serverOrdered() && !this.anyActive()) {
          /* server-owned order (native ?sort_by, Featured, or a twin collection): window by
             ABSOLUTE idx, so gift-placeholder holes and deep landings both stay honest */
          var lo = (this.cpPage - 1) * eff + 1, hi = this.cpPage * eff;
          if (this.cpPage >= this.cpPages) hi = Number.MAX_SAFE_INTEGER;   /* NZS-CMP-LASTPG-0817: last page runs to the very end. Was (_pagesTotal()||1)*36 -- assumes 36/server-page, but the compare tool's nzs-full mega-page makes _pagesTotal()===1 -> hi=36 < lo -> blank last page. pgHi below clamps to _pagesTotal so shortOf is unchanged. */
          for (i = 0; i < recs.length; i++) {
            rec = recs[i];
            if (rec.idx >= lo && rec.idx <= hi && !rec.hidden) list.push(rec);
          }
          var pgLo = Math.max(1, Math.ceil(lo / 36));
          var pgHi = Math.min(this._pagesTotal() || 1, Math.ceil(hi / 36));
          for (var p2 = pgLo; p2 <= pgHi; p2++) { if (!this._loadedPages || !this._loadedPages[p2]) { shortOf = true; break; } }
        } else {
          /* client-owned set (any filter, or a client-ranked sort): window the MATCHING records
             ordinally, in rank order */
          var start = (this.cpPage - 1) * eff, end = start + eff, m = 0;
          for (i = 0; i < recs.length; i++) {
            rec = recs[i];
            if (rec.hidden) continue;
            if (m >= start && m < end) list.push(rec);
            m++;
          }
          shortOf = !this._allPagesLoaded && list.length < eff;
        }
        this._windowShort = shortOf;
        if (this._paging) {
          // ponytail: wait for the existing record loader, then reuse its card materializer.
          if ((shortOf || this._loadingMore) && !this._loadError) { this.showLoader(false); return; }
          var previous = this._paging; this._paging = null; this.pagingSize = 0; this.pagingPage = 0;
          if (this._loadError) {
            this.perPage = previous.size; this.cpPage = previous.page; this.writeUrl(true);
            this.pagingError = 'Could not load products. Please choose the page or size again.';
            this.applyPageWindow(); return;
          }
          this._pagingScroll = window.scrollY; this._pagingAnchor = document.documentElement.style.overflowAnchor;
          document.documentElement.style.overflowAnchor = 'none';
        }
        this._materialize(list);
        if (this._pagingScroll != null && !this._matPending) {
          window.scrollTo({top:this._pagingScroll,behavior:'instant'});
          document.documentElement.style.overflowAnchor = this._pagingAnchor; this._pagingScroll = null;
        }
        /* Blake's loader rule: under the cards, above the pager, visible ONLY while the selected
           page size hasn't fully landed (or a sort swap is being fetched). */
        if (!this._loadingMore) this.showLoader(false);
        else this.showLoader(shortOf || this._clientSwap || this._swapping);
      },

      /* ---------- NZS-PGN4 motion (/motion-design, Corporate/Premium archetype) ---------- */
      /* Dim via class: 250ms eased opacity + ambient shimmer sweep (CSS NZS-MOTION-0807).
         NZS-SPD-0808: the inline-opacity belt is gone — .nzs-grid--sorting already sets
         opacity:.45 (nzs-base.css:5057) and the inline copy only defeated the transition. */
      _dimGrid(on) {
        if (!this._liveGrid()) return;   /* NZS-SPD-0808g */
        if (on) {
          this.grid.classList.add('nzs-grid--sorting');
          this.grid.setAttribute('aria-busy', 'true');
          this.grid.style.pointerEvents = 'none';
        } else {
          this.grid.classList.remove('nzs-grid--sorting');
          this.grid.removeAttribute('aria-busy');
          this.grid.style.pointerEvents = '';
        }
      },
      /* Resolution: the landed window cascades in — 220ms rise+fade per card, 25ms stagger
         capped at 12 steps (total ≤ ~520ms, stagger budget ≤300ms). Sort swaps only. */
      _cascadeWindow() {
        if (this.isSearch || !this.grid) return;
        try {
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          var vis = this.grid.querySelectorAll('[data-nzs-card]:not(.nzs-hidden):not(.nzs-offpage)');
          var hadAny = false;
          for (var i = 0; i < vis.length && i < 80; i++) {
            var el = vis[i];
            el.style.setProperty('--nzs-i', Math.min(i, 12));
            if (el.classList.contains('nzs-card--in')) { hadAny = true; el.classList.remove('nzs-card--in'); }
          }
          if (hadAny) void this.grid.offsetWidth;   /* full-grid reflow ONLY when re-triggering a live cascade (PGN4b: the unconditional reflow cost seconds after a 761-node reorder) */
          for (var j = 0; j < vis.length && j < 80; j++) vis[j].classList.add('nzs-card--in');
          var g = this.grid;
          clearTimeout(this._cascT);
          this._cascT = setTimeout(function () {
            Array.prototype.forEach.call(g.querySelectorAll('.nzs-card--in'), function (n) { n.classList.remove('nzs-card--in'); });
          }, 900);
        } catch (e) {}
      },
      /* NZS-PGN4 (W-C1): belt-and-braces — a client sort that somehow left the window unsorted
         (SS1-class silent failures, whatever their cause) heals itself once, loudly in console. */
      _assertSortOrder() {
        if (this.isSearch || !this.grid || this._sortHealed) return;
        if (this._serverOwned()) return;   /* NZS-SPD-0808: never audit an order the server owns (twin mode) */
        var key = this.sort;
        if (key !== 'pps-asc' && key !== 'srv-desc') return;
        var vis = this.grid.querySelectorAll('[data-nzs-card]:not(.nzs-hidden):not(.nzs-offpage)');
        var bad = false, prev = null, i, el, v;
        for (i = 0; i < vis.length && i < 6; i++) {
          el = vis[i];
          if (key === 'pps-asc') {
            v = parseFloat(el.getAttribute('data-pps')) || 0; if (!(v > 0)) v = 1e12;
            if (prev != null && v < prev) { bad = true; break; }
          } else {
            v = parseFloat(el.getAttribute('data-srv')) || 0;
            if (prev != null && v > prev) { bad = true; break; }
          }
          prev = v;
        }
        if (!bad) return;
        this._sortHealed = true;
        console.warn('[nzs] sort self-heal: window order did not match "' + key + '" - re-applying');
        this.collectCards();
        this.apply(false);
        /* NZS-PGN5b: re-check after the heal — if the window is STILL wrong, reload in place;
           the URL carries ?sort= so the SSR landing path takes over (always completes). */
        var self2 = this, key2 = key;
        setTimeout(function () {
          if (self2.sort !== key2 || self2.isSearch || !self2.grid) return;
          var vis2 = self2.grid.querySelectorAll('[data-nzs-card]:not(.nzs-hidden):not(.nzs-offpage)');
          var prev2 = null, bad2 = false;
          for (var m = 0; m < vis2.length && m < 6; m++) {
            var vv = key2 === 'pps-asc' ? (parseFloat(vis2[m].getAttribute('data-pps')) || 0) : (parseFloat(vis2[m].getAttribute('data-srv')) || 0);
            if (key2 === 'pps-asc') { if (!(vv > 0)) vv = 1e12; if (prev2 != null && vv < prev2) { bad2 = true; break; } }
            else if (prev2 != null && vv > prev2) { bad2 = true; break; }
            prev2 = vv;
          }
          if (bad2) { try { location.reload(); } catch (e) {} }
        }, 400);
      },

      /* ---------- control handlers ---------- */
      /* NZS-SPD-0927-B3-SLURL (owner-approved Tier C, 28 Sep: "While dragging the price slider..."): for the PRICE slider
         (predicate: s.kind === 'price', search and collections) each input used to replaceState + pgnSync (+ Labeler's and
         gtag's history wrappers). It still rewrites the pager hrefs every input (pgnSync: same hrefs as today, since they
         are built from state over location's unmanaged params; cheap with D7's cached links), but only computes the SAME
         href writeUrl(true) would have written and parks it. _slUrlFlush() replays it as one replaceState into the entry it
         belongs to: at thumb release (change), before any other history write of ours, before afterLoadMore rebuilds state
         from the URL, and on every traversal (_slUrlNav, before the entry switches); pagehide is a best-effort extra. So
         Back/Forward and every entry's URL are what they were; only the address bar lags while the thumb is held (see
         _slUrlNav for the two third-party-only edges). Other sliders, and browsers without the Navigation API (no traversal
         hook: Safari/Firefox versions without it), keep today's per-input writeUrl(true) exactly. */
      onSlider(s) {
        if (s.lo > s.hi) { var t = s.lo; s.lo = s.hi; s.hi = t; }
        this.applyDebounced();
        if (s.kind === 'price' && this.ready && window.navigation) { this._slUrl = this.writeUrl(true, true); this.pgnSync(); }
        else this.writeUrl(true);
      },
      pct(s, v) { return ((v - s.min) / (s.max - s.min) * 100); },
      fmt(s, v) {
        var x = v / s.div;
        if (s.unit === '$') return '$' + x.toFixed(2);
        if (s.unit === 'mg') return Math.round(v) + 'mg';
        if (s.unit === 'g') return (Math.round(x * 10) / 10) + 'g';
        return Math.round(x);
      },
      toggleCheck(arr, val) { var i = arr.indexOf(val); if (i >= 0) arr.splice(i, 1); else arr.push(val); this.apply(); },
      toggleAvailability() { this.availabilityOn = !this.availabilityOn; this.apply(); },
      /* NZS-SORT2-0805: the four Shopify-native sorts (featured/price-asc/price-desc/title-asc)
         are ordered by the SERVER via ?sort_by, so their pages arrive already globally sorted and
         the client never re-orders them. price-per-serve and servings have no Shopify equivalent
         and stay client-side over the fully-loaded set. On /search there is no server sort, so
         all sorts stay client-side (isSearch -> not server-sortable). */
      _serverSortable() { return !this.isSearch && Object.prototype.hasOwnProperty.call(NZS_SHOPIFY_SORT, this.sort); },
      _sortByParam() { return this._serverSortable() ? (NZS_SHOPIFY_SORT[this.sort] || '') : ''; },

      /* ---------- NZS-SPD-0808: twin fast path ----------
         $/serve and Servings have no Shopify sort, so today they cost the FULL catalogue. Two
         maintained twin collections hold the same products pre-ordered by those two keys; when
         the sort is pristine (no filters) we fetch WINDOW pages from the twin and the order is
         the server's again — 1-3 requests instead of 21. Any validation failure kills the twins
         for the session and today's client-sort path takes over unchanged. */
      _readTwins() {
        var root = this.$root, raw = null, host;
        if (!root || this.isSearch) return;
        raw = root.getAttribute('data-nzs-twins');
        if (!raw) { host = root.querySelector('[data-nzs-twins]'); if (host) raw = host.getAttribute('data-nzs-twins'); }
        if (!raw) { host = document.getElementById('nzs-twin-state'); if (host) raw = host.textContent; }
        this._twinBase = root.getAttribute('data-nzs-twin-base') || 'shop-all';
        if (!raw) return;
        var t = null;
        try { t = JSON.parse(raw); } catch (e) { return; }
        if (!t || typeof t !== 'object') return;
        var ok = {}, k, any = false;
        for (k in t) {
          if (k !== 'pps' && k !== 'srv') continue;
          var v = t[k];
          if (!v || typeof v.gen !== 'string' || !v.gen || !(v.count > 0)) continue;
          ok[k] = { gen: v.gen, count: v.count };
          any = true;
        }
        if (any) this._twins = ok;
      },
      /* '' when the twins cannot own this render; otherwise 'pps' | 'srv' */
      _twinActive() {
        if (this.isSearch || this._twinDead || !this._twins) return '';
        var k = this.sort === 'pps-asc' ? 'pps' : (this.sort === 'srv-desc' ? 'srv' : '');
        if (!k || !this._twins[k]) return '';
        if (this.anyActive()) return '';   /* filtered sorts stay client-owned (v1) */
        /* the twins mirror ONE collection: never let a shop-all-mode page (e.g. /collections/all,
           tested-for-sport) inherit them via a metafield fallback.
           NZS-SPD-0808b: and never a TAG-filtered view — /collections/shop-all/vegan renders a
           SUBSET, but the twins hold the whole collection, so their pages would be wrong. */
        var seg = (location.pathname.split('/collections/')[1] || '').replace(/\/+$/, '');
        if (seg.indexOf('/') >= 0) return '';
        if (seg !== this._twinBase) return '';
        return k;
      },
      _handle() { return (location.pathname.split('/collections/')[1] || '').split('/')[0]; },
      _twinHandle(tw) { return tw === 'pps' ? 'shop-all-by-pps' : 'shop-all-by-servings'; },
      _transportPath(tw) {
        if (!tw) return location.pathname;
        var m = location.pathname.match(/^(.*)\/collections\//);   /* keep any locale/market prefix */
        return (m ? m[1] : '') + '/collections/' + this._twinHandle(tw);
      },
      /* the key the loaded pages are stamped with — base pages and twin pages must never mix */
      _transportKey() { var tw = this._twinActive(); return tw ? ('twin:' + tw) : (this._sortByParam() || ''); },
      _serverOwned() { return this._serverSortable() || !!this._twinActive(); },
      _pagesTotal() { return (this._twinActive() && this._twinPages) ? this._twinPages : this._collectionPages; },
      _twinValid(tw, parsed) {
        var t = this._twins && this._twins[tw];
        if (!t || !parsed) return false;
        if (parsed.gen !== t.gen) return false;              /* the sync generation the page was built at */
        if (parsed.total !== t.count) return false;          /* the twin drifted from its own sync record */
        /* NZS-SPD-0808c (Sol 2): the twin can agree with twin_state and still be STALE — a product
           added to shop-all at midday moves the BASE total while both twin numbers sit still. The
           SSR total is this page's ground truth, so demand all three agree. */
        if (this._srvTotal > 0 && t.count !== this._srvTotal) return false;
        if (parsed.dup) return false;                        /* repeated pid inside the page */
        /* NZS-SPD-0808c (Sol 4): on a TWIN page a pid-less card is not skippable — the twin's page
           N is a fixed 36-product slice of a global order, so dropping one renders a 35-card hole
           that no other page will ever fill. Base pages keep skip-the-record. */
        if (parsed.nopid) return false;
        /* NZS-SPD-0808b: dedup against the pids taken from twin pages, never against the global
           _seen — a restored base store (dropStale keepStale) shares every pid with the twins, so
           _seen guaranteed a false "duplicate" and retired the twins forever after any blip.
           NZS-SPD-0808c (Sol 3): this ledger lives as long as the twin TRANSPORT (cleared only by
           resetCollection), not one fill. Per-fill, a pid repeated across two twin pages fetched by
           two different fills slipped through here and was then swallowed by appendPage's _seen —
           a silent 35-card page instead of a caught corruption. A page is fetched at most once per
           transport life (_loadedPages clears with this), so there are no false positives. */
        var ts = this._twinSeen || {};
        for (var i = 0; i < parsed.recs.length; i++) { if (ts[parsed.recs[i].pid]) return false; }
        /* NZS-SPD-0808b: server-owned orders skip _assertSortOrder, so the page pays for itself —
           the head of every twin page must be monotone in the sort key. */
        return this._twinMonotonic(tw, parsed.recs);
      },
      /* first 6 records of a twin page, in the twin's own key: pps ascending (no-data parked last),
         srv descending. Mirrors the applySort comparators exactly. */
      _twinMonotonic(tw, recs) {
        var prev = null, i, v;
        for (i = 0; i < recs.length && i < 6; i++) {
          if (tw === 'pps') { v = recs[i].pps > 0 ? recs[i].pps : 1e12; if (prev != null && v < prev) return false; }
          else { v = recs[i].srv || 0; if (prev != null && v > prev) return false; }
          prev = v;
        }
        return true;
      },
      _twinFail(tw, where) {
        if (this._twinDead) return;
        this._twinDead = true;
        console.warn('[nzs] twin collection "' + this._twinHandle(tw) + '" failed validation (' + where + ') — falling back to the client sort');
        /* _twinActive() is '' from here, so _swapClient's own transport guard throws every
           twin-keyed page away and refetches the base pages: today's path, unchanged. */
        this._swapClient(null);
      },
      /* enter twin mode: the sort becomes a SERVER order, so the grid reloads from the twin the
         same way a ?sort_by swap reloads from the base collection */
      /* NZS-SPD-0808e: the 0808d self-latch here, and the restart flag in filterIntent, are both
         GONE. They suppressed re-entry by refusing to run — which is exactly how the reset's own
         fetch scheduling got swallowed (live STATE 2/3). The transition is now deferred to a clean
         stack and guarded structurally by _transportSb === null, so there is nothing left to
         suppress. */
      _twinEnter(scrollTop, prevSort, keepCp) {
        this._tookOver = true;   /* the real ?page links are base-ordered — the client pager owns nav */
        this._twinPages = 0;
        /* NZS-SPD-0808c: keepCp is explicit now. A ?cp landing keeps its page; a sort pick and a
           filter-clear both restart at 1 (apply() zeroes cpPage right after filterIntent anyway,
           so preserving it there would fetch a window nobody is looking at). */
        if (keepCp === undefined) keepCp = !scrollTop;
        if (keepCp && this.cpPage > 1) this._keepCp = this.cpPage;
        if (this.ready) this.writeUrl();
        this.resetCollection(scrollTop, true, prevSort);
      },

      /* ---------- NZS-SPD-0808: Cache API read-through (10 min TTL, versioned bucket) ----------
         Absent/erroring/over-quota caches degrade to a plain fetch — never a second storage path. */
      /* NZS-SPD-0808b: the transport VIEW is part of the identity — an nzs-page body and an
         nzs-cards body are different documents under the same handle/sort/page.
         NZS-SPD-0808c (Sol 7): key on the normalised transport PATHNAME, not the bare handle — it
         is the exact path the request went to, so a locale/market prefix (/en-nz/…) and a twin
         collection each get their own namespace instead of colliding on 'shop-all'. */
      _cacheReq(n, tkey, path) {
        var key = 'nzs:' + (path || location.pathname) + ':' + (tkey || 'featured') + ':' + (this._transportView || 'nzs-page') + ':' + n;
        return new Request(location.origin + '/__nzs-spd/' + encodeURIComponent(key));
      },
      /* NZS-SPD-0808c (Sol 7): delete only buckets we KNOW are ours and superseded. A blanket
         'nzs-*' sweep is other people's data — any future NZS feature (or app) that opens its own
         cache would be silently wiped by a collection page load. This build is the first, so the
         list is empty; when the bucket name changes, add the old literal here. */
      _cacheSweep() {
        var OLD = [];   /* e.g. 'nzs-spd-0807' once a rename happens */
        if (!OLD.length) return;
        try {
          if (!window.caches || typeof caches.delete !== 'function') return;
          OLD.forEach(function (nm) { if (nm !== 'nzs-spd-0808') { try { caches.delete(nm); } catch (e) {} } });
        } catch (e) {}
      },
      _cacheOpen() {
        if (this._cacheP !== undefined) return this._cacheP;
        this._cacheP = null;
        try { if (window.caches && typeof caches.open === 'function') this._cacheP = caches.open('nzs-spd-0808').catch(function () { return null; }); }
        catch (e) { this._cacheP = null; }
        if (this._cacheP) this._cachePrune();
        return this._cacheP;
      },
      /* NZS-CACHE-PRUNE-0905: the 10-min TTL was only enforced on read, so keys (path x sort x view x page)
         piled up for weeks. Once per tab session, in idle time: drop expired entries, cap the bucket at 60. */
      _cachePrune() {
        try { if (sessionStorage.getItem('nzsSpdPruned')) return; sessionStorage.setItem('nzsSpdPruned', '1'); } catch (e) { return; }
        var p = this._cacheP;
        var run = function () {
          p.then(function (c) {
            if (!c) return;
            return c.keys().then(function (reqs) {
              var rows = [];
              return Promise.all(reqs.map(function (req) {
                return c.match(req).then(function (r) {
                  var ts = r ? parseInt(r.headers.get('x-nzs-ts') || '0', 10) : 0;
                  if (!ts || Date.now() - ts > 600000) return c.delete(req);
                  rows.push({ req: req, ts: ts });
                });
              })).then(function () {
                rows.sort(function (a, b) { return b.ts - a.ts; });
                return Promise.all(rows.slice(60).map(function (x) { return c.delete(x.req); }));
              });
            });
          }).catch(function () {});
        };
        (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(run);
      },
      _cacheGet(req, gen) {
        var p = this._cacheOpen();
        if (!p) return Promise.resolve(null);
        return p.then(function (c) {
          if (!c) return null;
          return c.match(req).then(function (r) {
            if (!r) return null;
            var ts = parseInt(r.headers.get('x-nzs-ts') || '0', 10);
            if (!ts || Date.now() - ts > 600000) { try { c.delete(req); } catch (e) {} return null; }
            return r.text().then(function (txt) {
              /* twin pages: a cached page built at an older generation is a miss, not a mismatch */
              if (gen && txt.indexOf('data-nzs-gen="' + gen + '"') < 0) { try { c.delete(req); } catch (e) {} return null; }
              return txt;
            });
          });
        }).catch(function () { return null; });
      },
      _cachePut(req, text, n) {
        /* NZS-SPD-0808b: only the pages a shopper can plausibly reach by browsing are worth
           storing — a full 21-page filter fill must not dump the whole catalogue into Cache
           Storage on every visit. */
        if (n > 30) return;
        var p = this._cacheOpen();
        if (!p) return;
        p.then(function (c) {
          if (!c) return;
          return c.put(req, new Response(text, { headers: { 'content-type': 'text/html;charset=utf-8', 'x-nzs-ts': String(Date.now()) } }));
        }).catch(function () {});   /* quota / private mode: silently skip */
      },
      setSort(k) {
        if (k === this.sort) return;
        var prevSort = this.sort;   /* NZS-SORT3-0806: kept for rollback if the swap fetch fails */
        this.sort = k;
        this._foreignSb = null;   /* SEV3-B: an explicit pick replaces a foreign ?sort_by */
        this._sortHealed = false; /* NZS-PGN4: each pick gets one self-heal budget */
        if (this.isSearch) { this.apply(); return; }
        /* NZS-SPD-0808: a pristine $/serve or Servings pick is a SERVER order now — reload the
           window from the twin collection instead of pulling the whole catalogue. */
        if (this._twinActive()) { this._twinEnter(true, prevSort); return; }
        if (this._serverSortable()) {
          var sb = this._sortByParam() || '';
          if (this._transportSb === sb && this._loadedPages && Object.keys(this._loadedPages).length) {
            if (this._clientSwap || this._loadingMore) this.abortLoad();   /* B-N1: never leave a superseded fill's dim/_fillDone armed */
            /* NZS-PGN3: the loaded pages were fetched under this exact server order (e.g. back to
               Featured after a client sort — client fills fetch in featured order): restore the
               server (idx) order and re-window, zero refetch.
               NZS-SPD-0808: "restoring" is now just applySort picking this.order — no 761-node
               DOM replay (the old fragment dance moved every card in the grid). */
            this.cpPage = 1;
            this.writeUrl();
            this.apply(false);
            this.ensureWindow();
            this._cascadeWindow();   /* NZS-PGN4: instant reuse swap still reads as a swap */
            this.scrollGridTop();
            return;
          }
          this.writeUrl(); this.resetCollection(true, true, prevSort);  // push ?sort_by, reload in server order
          return;
        }
        this._swapClient(prevSort);   // pps/srv: grey + full fill + one-paint ranked swap
      },
      scrollGridTop() {
        if (!this.grid) return;
        try {
          var y = this.grid.getBoundingClientRect().top + window.pageYOffset -
            ((parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nzs-hdr-b')) || 0) + 16);
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        } catch (e) {}
      },
      /* NZS-PGN3: a client-only sort (pps/srv) — grey the grid + loader until every page is in,
         rank the FULL matching set, then swap in one paint. prevSort=null on a landing that already
         carries the sort (nothing to roll back to). */
      _swapClient(prevSort) {
        var self = this;
        /* F3: never piggyback a small window/warm fetch — its finish would fire _fillDone with
           the set still incomplete and silently roll the sort back. Supersede it; the full fill
           refetches only what is missing. */
        if (this._loadingMore) this.abortLoad();
        var _want = this._transportKey();
        if (!this._allPagesLoaded && this._transportSb != null && this._transportSb !== _want &&
            this._loadedPages && Object.keys(this._loadedPages).length) {
          this.resetCollection(false, true, null);   /* SEV1-A: throw the mixed-transport partial away; its abortLoad ran before the arm below */
        }
        this._clientSwap = true;
        this._swapPrevSort = prevSort;
        this.cpPage = 1;
        this._tookOver = true;
        if (this.ready) this.writeUrl();
        this._dimGrid(true);
        this.showLoader(true);
        var done = function (ok) {
          /* NZS-SPD-0808: the silent-retry layer is gone — the reload fallback below is the
             one recovery path (it always completes via the SSR landing). */
          if (!ok && prevSort != null) {
            /* NZS-PGN5 (Blake): the URL already carries this sort — reload in place and land on
               the SSR path, which always completes. Better one visible reload than a silent
               rollback that reads as "the sort ignored me". Landing swaps (prevSort null) keep
               the rollback so a failing landing can never reload-loop. */
            try { location.reload(); return; } catch (e) {}
          }
          self._clientSwap = false;
          var prev = self._swapPrevSort; self._swapPrevSort = null;
          if (!ok && prev && prev !== self.sort) { self.sort = prev; if (self.ready) self.writeUrl(true); }
          self.collectCards();   /* NZS-PGN5b: NEVER trust the stale-cards guard here — a hidden-tab fill was observed settling with this.cards still at the SSR 36 */
          self.apply(false);
          self._dimGrid(false);
          self.showLoader(false);
          if (ok) self._assertSortOrder();
          if (ok) self._cascadeWindow();
          if (ok && prevSort != null) self.scrollGridTop();   /* F3b: never yank a LANDING (?sort= in URL) */
        };
        if (this._allPagesLoaded) { done(true); return; }
        this._fillDone = done;
        this.filterIntent();
      },
      /* NZS-SPD-0808: the sort-menu pre-warm is DELETED — opening the Sort menu used to fetch and
         materialise the whole catalogue (16.7MB / 106k DOM nodes) on the CHANCE the shopper picked
         $/serve. The record store + twin fast path make the sort itself cheap, so the speculation
         bought nothing and cost everything. Lane L removed the call site. */
      /* ---------- NZS-PGN3: Products/page selector + bounded client pager ---------- */
      get displayedPerPage() { return this._paging ? this._paging.size : this.perPage; },
      beginPaging(size, page) {
        var previous = this._paging || {size:this.perPage,page:this.cpPage};
        if (this._loadingMore) this.abortLoad();
        this._paging = previous; this.pagingSize = size || 0; this.pagingPage = page || 0; this.pagingError = '';
      },
      setPerPage(n) {
        n = parseInt(n, 10) || 0;
        if (this.ppOptions.indexOf(n) < 0) n = 0;
        if (n === this.perPage && !this.pagingError) return;
        this.beginPaging(n, 0);
        var firstOrd = (this.cpPage - 1) * this.effPerPage + 1;   // keep the shopper where they were
        this.perPage = n;
        this._tookOver = true;
        this.cpPage = Math.max(1, Math.ceil(firstOrd / this.effPerPage));
        this.ensureWindow();
        this.apply(false);
        this.writeUrl(false);
      },
      cpGo(n) {
        n = Math.max(1, Math.min(parseInt(n, 10) || 1, this.cpPages || 1));
        if (n === this.cpPage) {
          /* SEV3-A: re-clicking the current page after a failed window fetch retries it */
          if (this._windowShort && !this._loadingMore) this.ensureWindow();
          return;
        }
        this.beginPaging(0, n);
        this.cpPage = n;
        this._tookOver = true;
        this.ensureWindow();
        this.applyPageWindow();
        this.writeUrl(false);
      },
      /* A client-only sort (pps/srv) needs every page before it can be correct; so does any active
         filter (for an exact count + full filtered set). A server sort with no filter loads
         progressively on scroll instead. */
      _needsFullSet() { return (!this._serverOwned()) || this.anyActive(); },
      /* NZS-SORT-CLIENT: "the client owns the result set" - a filter is applied, or a sort is.
         Kept separate from anyActive() (which means strictly "a filter is applied") because
         the toolbar dot and the product count must not react to sorting. */
      _clientOwns() { return this.anyActive() || this._needsFullSet(); },
      get sortLabel() { var s = this.sorts.filter(function (x) { return x.key === this.sort; }.bind(this))[0]; return s ? s.label : 'Featured'; },
      setDensity(d) { this.density = d; localStorage.setItem('nzs-density3', d); this.writeUrl(); this.$nextTick(function () { this.repadWindow(); }.bind(this)); },
      setCat(k) { this.cat = (this.cat === k ? '' : k); this.buildControls(); this.apply(); },

      /* ---------- NZS-PGN: keep the visible server pager hrefs honest ---------- */
      pgnSync() {
        /* Rewrite every server page link from LIVE state. Without this the hrefs keep the query
           string of the original request, so page 2 threw away whatever the shopper filtered by. */
        /* NZS-SPD-0927-B3-D7 (Tier A part): on /search the pager links and row are cached on the section root. They are
           server HTML (snippets/nzs-pagination.liquid, no x-for/x-if around them); pgnSync only rewrites href, and no theme
           script inserts, removes or moves a [data-nzs-pgn-link] (grep 28 Sep: only nzs-filters.js touches nzs-pgn), so the
           list is the same elements in the same order as a fresh query. A replaced pager disconnects them and re-queries.
           An empty result is never cached. Collections re-query as before (their grid can be swapped under _watchGrid).
           The no-op-href skip (D7 Tier B) is NOT done. */
        var _pr = this.$root, _pc = this.isSearch && _pr ? _pr._nzsPgnC : null;
        if (!_pc || !_pc.links[0].isConnected || !_pc.row || !_pc.row.isConnected) {
          var _pl = _pr ? _pr.querySelectorAll('[data-nzs-pgn-link]') : null;
          _pc = { links: _pl, row: (_pl && _pl.length) ? _pr.querySelector('.nzs-pgnrow') : null };
          if (this.isSearch && _pc.row) _pr._nzsPgnC = _pc;
        }
        var links = _pc.links;
        if (!links || !links.length) return;
        /* Seed from the row's force params FIRST (q, type=product on search) --
           they are server-meaningful constants the SSR href carried; without
           this seed a pgnSync after e.g. a density change would drop them
           whenever they are missing from location.search. Live state then
           overlays, so a real q in the URL still wins. */
        var seeded = new URLSearchParams();
        var rowEl = _pc.row;   /* NZS-SPD-0927-B3-D7: the row the (cached or fresh) query above found */
        if (rowEl && rowEl.getAttribute('data-nzs-pgn-force')) {
          new URLSearchParams(rowEl.getAttribute('data-nzs-pgn-force')).forEach(function (v, k) { seeded.set(k, v); });
        }
        this._stateParams().forEach(function (v, k) { seeded.set(k, v); });
        var base = seeded.toString();
        Array.prototype.forEach.call(links, function (a) {
          var n = parseInt(a.getAttribute('data-nzs-pgn-page') || '1', 10) || 1;
          var p = new URLSearchParams(base);
          if (n > 1) p.set('page', n); else p.delete('page');   // page 1 stays the clean URL
          var q = p.toString();
          a.setAttribute('href', a.pathname + (q ? '?' + q : '') + a.hash);
        });
      },
      anyActive() {
        // NZS-CATCHIPS: a picked shop-all category chip counts as an active filter (drives the full page
        // load + the filtered count); NZS-TFS: so does the Tested for Sport toggle.
        return this.sliders.some(this.sliderActive) || this.groups.some(function (g) { return g.sel.length; }) ||
          (this.flavour && this.flavour.sel.length) || this.toggles.some(function (t) { return t.on; }) || this.availabilityOn || this.testedOn || this.subcatSel.length || this.catSel.length || (this.shopAll && !!this.cat);
      },
      reset() {
        this.sliders.forEach(function (s) { s.lo = s.min; s.hi = s.max; });
        this.groups.forEach(function (g) { g.sel.splice(0); });
        if (this.flavour) this.flavour.sel.splice(0);
        this.toggles.forEach(function (t) { t.on = false; });
        this.availabilityOn = false;
        this.testedOn = false;
        this.subcatSel.splice(0);
        this.catSel.splice(0);
        if (this.shopAll) this.cat = '';
        this.apply();
      },

      /* ---------- URL state ---------- */
      /* NZS-PGN: the ONE definition of "the managed params for the current state". writeUrl() and
         pgnSync() both build on it, so the address bar and the pagination hrefs cannot drift apart.
         'page' is deliberately NOT set here — each caller supplies the page it means. */
      _stateParams() {
        var url = new URL(location.href), p = url.searchParams;
        var managed = ['cat', 'catf', 'sub', 'price', 'pps', 'srv', 'grams', 'flavour', 't', 'tfs', 'avail', 'sort', 'sort_by', 'density', 'page', 'pp', 'cp'];
        (this.cfg.tagGroups || []).forEach(function (g) { managed.push(g.ns); });
        Object.keys(this.cfg.categories || {}).forEach(function (k) { (this.cfg.categories[k].ingredients || []).forEach(function (i) { managed.push(i.key); }); }.bind(this));
        managed.forEach(function (key) { p.delete(key); });
        if (this.isSearch) p.set('type', this.baseParams.get('type'));
        if (this.shopAll && this.cat) p.set('cat', this.cat);
        if (this.catSel.length) p.set('catf', this.catSel.join(','));
        if (this.subcatSel.length) p.set('sub', this.subcatSel.join(','));
        this.sliders.forEach(function (s) { if (this.sliderActive(s)) p.set(s.kind === 'ing' ? s.key : s.kind, s.lo + '-' + s.hi); }.bind(this));
        this.groups.forEach(function (g) { if (g.sel.length) p.set(g.ns, g.sel.join(',')); });
        if (this.flavour && this.flavour.sel.length) p.set('flavour', this.flavour.sel.join(','));
        var on = this.toggles.filter(function (t) { return t.on; }).map(function (t) { return t.key; });
        if (on.length) p.set('t', on.join(','));
        if (this.availabilityOn) p.set('avail', '1');
        if (this.testedOn) p.set('tfs', '1');
        /* NZS-SORT2-0805: native sorts are server-ordered, so their canonical URL key is ?sort_by
           (address bar + reload + share + the SSR first paint all agree, and Featured is just the
           clean URL). The two client-only sorts (pps/srv) and every /search sort keep the private
           ?sort key. hydrateFromUrl still reads both. */
        if (this._foreignSb) {
          p.set('sort_by', this._foreignSb);   /* SEV3-B: keep an unmapped server sort alive */
        } else if (this._serverSortable()) {
          var _sb = NZS_SHOPIFY_SORT[this.sort];
          if (_sb) p.set('sort_by', _sb);
        } else if (this.sort !== 'featured') {
          p.set('sort', this.sort);
        }
        if (!this.isSearch) {   /* SEV2-D: bounded-page state survives reload / product->Back */
          if (this.perPage) p.set('pp', this.perPage);
          if (this._tookOver && this.cpPage > 1) p.set('cp', this.cpPage);
        }
        if (this.density !== 'small') p.set('density', this.density);
        return p;
      },
      writeUrl(replace, hrefOnly) {
        if (!this.ready) return;
        if (!this.isSearch && replace !== false) replace = true;   /* NZS-PAGE-0806: collections never push — Back leaves the page instead of replaying a stale slice */
        if (!hrefOnly) this._slUrlFlush();   /* NZS-SPD-0927-B3-SLURL: a parked slider href goes first, as it did per input */
        var url = new URL(location.href), p = this._stateParams();
        /* NZS-PGN3: ?page stays a SERVER concept — the client pager's pages are size-dependent
           slices that a reload could not reproduce, so they keep the clean URL. /search keeps its
           old srvPage cursor untouched (F4). */
        if (this.isSearch) { if (this.srvPage > 1) p.set('page', this.srvPage); }
        else if (this.useServerPager && this.cpPage > 1) p.set('page', this.cpPage);
        url.search = p.toString();
        if (hrefOnly) return url.href;   /* NZS-SPD-0927-B3-SLURL: onSlider parks this instead of writing it */
        try { history[replace ? 'replaceState' : 'pushState']({}, '', url.href); } catch (e) {}
        this.pgnSync();
      },
      /* NZS-SPD-0927-B3-SLURL: the href is built from managed state over location's unmanaged params, which a slider never
         changes, so parking it while location lags yields the very string the per-input write produced. */
      _slUrlFlush() { var u = this._slUrl; if (u) { this._slUrl = null; try { history.replaceState({}, '', u); } catch (e) {} } },
      /* NZS-SPD-0927-B3-SLURL: a parked href must land in ITS entry whatever navigation comes (headless Chrome 28 Sep,
         src/test_b3_slurl_chrome.py -> out/b3_slurl_chrome.json):
         - a traversal the page cannot cancel (browser Back/Forward, any cross-document one) still has the old entry current
           while navigate fires, and a replaceState there lands in that entry without stopping the traversal;
         - a cancelable (script) traversal or reload WOULD be aborted by that write, so it is cancelled, the href written,
           and the same navigation re-issued (traverseTo(key) one task later; reload at once). Any navigation that starts
           before the delayed traverseTo runs supersedes it (_slReissue cleared), so a stale re-issue never lands after a
           newer request. Residual (headless Chrome 28 Sep): two SCRIPT navigations issued in the same task while the
           thumb is held (history.back() twice, or history.back() + a link click) end on a different entry than today;
           back + forward, back + #hash and #hash + back match;
         - a cancelable same-document fragment navigation (#hash link, location.hash) is cancelled, the href written into
           the entry being left, and the fragment navigation re-issued from it (push or replace, as asked), so the two
           entries are today's: price URL, then price URL + #hash;
         - a cross-document push (link, form, typed URL) cannot take the write without being cancelled, so it is left to
           the best-effort pagehide flush (it landed for a link and a typed URL, and is lost on a browser reload, which
           fires no navigate event: that entry keeps its pre-drag URL);
         - a foreign same-document replace drops the href (the entry gets their URL, as today; if they build it from
           location.search it lacks the in-drag price param), a foreign non-fragment pushState also drops it (the entry left
           keeps its pre-drag URL). Third-party-only: no theme script writes history on these pages mid-drag, and Labeler's
           and gtag's wrappers only observe. The change flush at release leaves nothing parked outside a held thumb. */
      _slUrlNav(e) {
        if (this._slReissue) this._slReissue = null;   /* a newer navigation supersedes a pending re-issue */
        if (!this._slUrl) return;
        var t = e.navigationType, self = this;
        if (t === 'traverse' || t === 'reload') {
          if (!e.cancelable) { this._slUrlFlush(); return; }
          var key = e.destination.key;
          e.preventDefault(); this._slUrlFlush();
          if (t === 'reload') { location.reload(); return; }
          this._slReissue = key;
          setTimeout(function () { if (self._slReissue !== key) return; self._slReissue = null; window.navigation.traverseTo(key); }, 0);
        } else if (e.destination.sameDocument && e.hashChange && e.cancelable) {
          var hash = new URL(e.destination.url).hash;
          e.preventDefault(); this._slUrlFlush();
          var target = location.href.split('#')[0] + hash;
          if (t === 'replace') location.replace(target); else location.assign(target);
        } else if (e.destination.sameDocument) this._slUrl = null;
      },
      hydrateFromUrl() {
        var url = new URL(location.href);
        var p = url.searchParams;
        if (p.has('cat') && this.shopAll) { this.cat = p.get('cat'); this.buildControls(); }
        if (p.get('catf')) this.catSel = p.get('catf').split(',').filter(Boolean);
        if (p.get('sub')) this.subcatSel = p.get('sub').split(',').filter(Boolean);
        this.sliders.forEach(function (s) {
          var raw = p.get(s.kind === 'ing' ? s.key : s.kind); if (!raw) return;
          var m = raw.split('-'); if (m.length === 2) { var lo = parseFloat(m[0]), hi = parseFloat(m[1]); if (isFinite(lo)) s.lo = Math.max(s.min, lo); if (isFinite(hi)) s.hi = Math.min(s.max, hi); }
          if (s.kind === 'ing' && this.sliderActive(s) && !s._openRestored) s.open = true;
        }.bind(this));
        this.groups.forEach(function (g) {
          var raw = p.get(g.ns);
          if (raw) g.sel = raw.split(',').filter(Boolean);
          if (g.sel.length && !g._openRestored) g.open = true;
          if (g.sel.some(function (slug) { return g.options.slice(8).some(function (o) { return o.slug === slug; }); })) g.showAll = true;   /* NZS-SORT3-0806: every capped group, not just brand */
        });
        if (this.flavour && p.get('flavour')) {
          this.flavour.sel = p.get('flavour').split(',').filter(Boolean);
          if (this.flavour.sel.length && !this.flavour._openRestored) this.flavour.open = true;
        }
        if (p.get('t')) { var on = p.get('t').split(','); this.toggles.forEach(function (t) { t.on = on.indexOf(t.key) >= 0; }); }
        if (p.get('avail') === '1') this.availabilityOn = true;
        if (p.get('tfs') === '1') this.testedOn = true;
        // NZS-SORT-SERVER: sort_by wins; ?sort= is still read so existing links work.
        if (p.get('sort_by') && NZS_SORT_FROM_SHOPIFY[p.get('sort_by')]) {
          this.sort = NZS_SORT_FROM_SHOPIFY[p.get('sort_by')];
        } else if (p.get('sort')) { this.sort = p.get('sort'); }
        if (p.get('density') && p.get('density') !== 'list') this.density = p.get('density');
        /* NZS-PGN: ?page is the shared cursor. The server used it to pick the rendered slice; when
           the client pager takes over (per-page size, or a filter in 'pager' mode) it continues from
           the same number instead of snapping the shopper back to page 1. */
        this.srvPage = parseInt(p.get('page') || '1', 10) || 1;
        if (this.useServerPager) this.cpPage = this.srvPage;   /* NZS-PGN3: client modes keep their own cursor */
        if (!this.isSearch) {   /* SEV2-D: restore bounded-page state (kept current by every writeUrl) */
          var _pp = parseInt(p.get('pp') || '0', 10);
          if (_pp && this.ppOptions.indexOf(_pp) >= 0 && _pp !== this.perPage) { this.perPage = _pp; this._tookOver = true; }
          var _cp = parseInt(p.get('cp') || '0', 10) || 0;
          if (_cp > 1) { this.cpPage = _cp; this._tookOver = true; }
        }
      },

      /* ---------- infinite-scroll render window — /search only since NZS-PAGE-0806 ---------- */
      readCols() {
        var n = 0;
        if (this.grid) {
          var tpl = getComputedStyle(this.grid).gridTemplateColumns;
          if (tpl && tpl !== 'none') n = tpl.split(' ').filter(Boolean).length;
        }
        if (!n) {
          var wide = window.matchMedia('(min-width:768px)').matches;
          if (this.density === 'list') n = 1;
          else if (this.density === 'large') n = wide ? 3 : 1;
          else n = wide ? ((this.grid && parseInt(getComputedStyle(this.grid).getPropertyValue('--nzs-cols'), 10)) || 4) : 2;
        }
        return Math.max(1, n);
      },
      windowConsts() { var cols = this.readCols(); return { cols: cols, WINDOW0: 4 * cols, STEP: 3 * cols }; },
      setupScroll() {
        if (!this.grid) return;
        /* NZS-SPD-0808: Lane L removed the collection sentinel markup — every read below is
           already null-guarded, and /search keeps its own sentinel. */
        this.sentinel = this.$root.querySelector('[data-nzs-sentinel]');
        this.loaderEl = this.$root.querySelector('[data-nzs-scroll-loader]');
        if (this.isSearch) this._soldOutBadgeWatch();   /* NZS-SPD-0808b: /search has no CSS hook — see the method */
        else this._watchGrid();                          /* NZS-SPD-0808g: notice a replaced grid element */
        var self = this;
        if (this.isSearch && this.sentinel && 'IntersectionObserver' in window) {   /* NZS-PGN3: collections stream nothing on scroll */
          this._io = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) { if (entries[i].isIntersecting) { self.onSentinel(); break; } }
          }, { root: null, rootMargin: '600px 0px', threshold: 0 });
          this._io.observe(this.sentinel);
        }
        window.addEventListener('resize', function () { clearTimeout(self._rt); self._rt = setTimeout(function () { self.onResize(); }, 150); });
      },
      resetWindow(k0) { var k = k0 || this.windowConsts(); this.shown = k.WINDOW0; this.applyWindow(k); },   /* NZS-SPD-0927-B3-D2: same k (only `shown` changed in between) */
      repadWindow() {
        var k = this.windowConsts();
        if (this.shown < k.WINDOW0) this.shown = k.WINDOW0;
        else this.shown = Math.ceil(this.shown / k.cols) * k.cols;
        this.applyWindow();
      },
      applyWindow(k0) {
        if (!this.grid || !this.isSearch) return;   /* NZS-PAGE-0806: /search-only */
        var k = k0 || this.windowConsts(); this._cols = k.cols;   /* NZS-SPD-0927-B3-D2: onSentinel/repadWindow/onResize still pass nothing and re-read */
        if (!this.shown || this.shown < k.WINDOW0) this.shown = k.WINDOW0;
        /* NZS-SORT2-0805: one visibility model now — the scroll-reveal window. Reveal the first
           `shown` matches (grown by onSentinel), page the rest out with .nzs-paged. The old
           'page' (numbered pager) and 'all' (fixed 36 + server pager) modes are retired; the
           collection streams progressively and /search behaves exactly as it did in 'window'. */
        var kids = this.grid.children, el, i, lo = 0, hi = this.shown, matching = 0;
        var newly = [];
        for (i = 0; i < kids.length; i++) {
          el = kids[i];
          if (!el.hasAttribute || !el.hasAttribute('data-nzs-card')) continue;
          if (el.classList.contains('nzs-hidden')) { el.classList.remove('nzs-paged'); continue; }
          matching++;
          if (matching > lo && matching <= hi) {
            if (el.classList.contains('nzs-paged')) el.classList.remove('nzs-paged');
            if (!el._nzsRevealed) { el._nzsRevealed = true; newly.push(el); }
          } else {
            el.classList.add('nzs-paged');
          }
        }
        this._matchingCount = matching;
        this.revealCards(newly);
        this.updateSentinel(matching);
      },
      updateSentinel(matching) {
        /* Search: more to REVEAL (window) or an eager load in flight. Collection: more PAGES for
           the forward cursor to stream (a chunked fill covers itself via _loadingMore; a
           bottomed-out deep landing with unfetched HEAD pages must not busy-loop the sentinel). */
        var more;
        if (this.isSearch) more = (this.shown < matching) || this._loadingMore;
        else more = this._loadingMore;   /* NZS-PGN3: collections no longer stream on scroll */
        if (this.sentinel) this.sentinel.style.display = more ? '' : 'none';
        if (!more) this.showLoader(false);
      },
      showLoader(on) { if (this._paging) on = false; if (this.loaderEl) { if (on) this.loaderEl.removeAttribute('hidden'); else this.loaderEl.setAttribute('hidden', ''); } },
      /* NZS-SPD-0808b: /search ONLY. C2 confirmed /search cards come from main-search /
         nzs-search-data, which do NOT get Lane L's new CSS hook, so /search keeps the live
         relocation behaviour verbatim (body byte-identical to live\; the ONLY delta is the
         isSearch gate on the call site in setupScroll). Collections are CSS-only now — a
         grid-wide subtree MutationObserver is exactly the wrong shape when the window
         materialises and evicts cards continuously. */
      /* NZS-PGN4 (W-D1): re-home the injected SOLD OUT badge (labels-and-badges.js) from the
         corner-stacked .label-container onto the image <a>, so CSS can centre it on the image
         below 1280px. Badges only carry config-specific x-badge-{id} classes — text match is the
         stable signal on this store. One-shot per badge; other labels stay stacked untouched. */
      _soldOutBadgeWatch() {
        if (!this.grid || this._sobMo) return;
        var relocate = function (b) {
          if (!b || b._nzsRelocated || !b.classList || !b.classList.contains('x-badge-container')) return;
          if ((b.textContent || '').trim().toLowerCase() !== 'sold out') return;
          var a = b.closest('a.x-labels-data') || b.closest('a');
          if (!a) return;
          b._nzsRelocated = true;
          b.classList.add('nzs-soldout-badge');
          a.appendChild(b);
        };
        Array.prototype.forEach.call(this.grid.querySelectorAll('.x-badge-container'), relocate);
        try {
          this._sobMo = new MutationObserver(function (muts) {
            for (var i = 0; i < muts.length; i++) {
              var m = muts[i];
              for (var j = 0; j < m.addedNodes.length; j++) {
                var n = m.addedNodes[j];
                if (n.nodeType !== 1) continue;
                relocate(n);
                if (n.querySelectorAll) Array.prototype.forEach.call(n.querySelectorAll('.x-badge-container'), relocate);
              }
            }
          });
          this._sobMo.observe(this.grid, { childList: true, subtree: true });
        } catch (e) {}
      },
      onSentinel() {
        if (!this.ready || this._swapping) return;   /* NZS-SORT3-0806 */
        if (!this.isSearch) return;   /* NZS-PGN3: bounded pages — nothing streams on scroll */
        if (this._winBusy || this.shown >= this._matchingCount) return;
        this._winBusy = true; this.showLoader(true);
        var self = this, k = this.windowConsts();
        setTimeout(function () {
          self.shown += k.STEP; self.applyWindow(); self._winBusy = false;
          if (!self._loadingMore) self.showLoader(self.shown < self._matchingCount);
        }, 200);
      },
      onResize() {
        var cols = this.readCols();
        if (cols === this._cols) return;
        this.repadWindow();
      },
      /* reveal a batch imperatively so a windowed image can never stay stuck at opacity:0; force the
         in-window images to load now so the first 4 rows (and each scrolled batch) are ready, and the
         hover/2nd image is loaded before Splide mounts (kills the hover-fades-to-white). */
      revealCards(els, forceEager) {
        if (!els || !els.length) return;
        var eager = forceEager !== false;   /* /search reveal window forces; collections use native lazy */
        els.forEach(function (card) {
          // NZS-FASTLOAD: bulk-loaded cards arrive cold; hydrate on first reveal, ~36 at a time.
          if (card.hasAttribute('data-nzs-needinit')) {
            card.removeAttribute('data-nzs-needinit');
            if (window.Alpine && window.Alpine.initTree) window.Alpine.initTree(card);
          }
          card.querySelectorAll('img.skeleton-image, img[loading="lazy"]').forEach(function (im) {
            var done = function () {
              im.classList.add('img-loaded', 'active');
              var sk = im.closest('.skeleton-image'); if (sk) sk.classList.remove('animate-Xpulse', 'skeleton-image');
              var ct = im.closest('.animate_transition_card__image'); if (ct) ct.classList.add('active', 'lazy_active');
            };
            if (im.complete && im.naturalWidth > 0) { done(); }
            else { im.addEventListener('load', done, { once: true }); im.addEventListener('error', done, { once: true }); if (eager) im.loading = 'eager'; }
          });
        });
      }
    };
  }

  /* NZS-SPD-0808: one registration. Both this file (section-level defer) and Alpine (vendors.js,
     defer, end of body) run in document order, so alpine:init always fires AFTER this listener is
     attached and the already-booted fallback was dead weight on every real page load.
     Restore `if (window.Alpine && window.Alpine.version) { try { window.Alpine.data('nzsFilters',
     nzsFilters); } catch (e) {} }` if a dynamically re-inserted section (theme editor) ever needs it. */
  document.addEventListener('alpine:init', function () { try { window.Alpine.data('nzsFilters', nzsFilters); } catch (e) { console.error('[nzs] nzsFilters init failed', e); } });
})();

;(function(){ if(window.__nzsCciBound) return; window.__nzsCciBound=true;
  document.addEventListener('click', function(e){
    var b=e.target.closest('.nzs-cci__sum'); if(!b) return;
    var c=b.closest('.nzs-cci'); if(!c) return;
    var open=c.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open?'true':'false');
  });
})();

;(function () {
  /* NZS-LAZYX-0907: collection cards past the first 8 render with x-ignore (see
     sections/nzs-collection.liquid). Wake them just before they are needed instead of paying
     36 card-component inits in Alpine's boot walk. */
  if (window.__nzsLazyx) return; window.__nzsLazyx = 1;
  function collect() { return [].slice.call(document.querySelectorAll('[data-nzs-lazyx]')); }
  var io = null;
  function wake(el) {
    if (!el || !el.hasAttribute || !el.hasAttribute('x-ignore')) return;
    el.removeAttribute('x-ignore');
    el.removeAttribute('data-nzs-lazyx');
    /* the attribute alone is not enough: x-ignore's inline handler sets el._x_ignore and only
       clears it on element teardown, and that PROPERTY is what Alpine actually tests. */
    delete el._x_ignore; delete el._x_ignoreSelf;
    if (io) io.unobserve(el);
    try { window.Alpine.initTree(el); }
    catch (e) { console.warn('[nzs-lazyx] initTree failed', e); }
  }
  function wakeAll() { collect().forEach(wake); }
  function start() {
    if (!collect().length) return;
    /* a filtered/sorted landing re-renders the grid during init, with no user gesture to hang a
       wake-all on -- so don't lazify it at all. ?page=N and the inert ad/analytics params are
       plain browses (a utm_/gclid landing is paid traffic and must keep the optimisation), so
       they stay lazy; anything else (filter.*, sort_by, q, ...) wakes every card now. */
    var okq = /^(page|utm_[a-z]+|gclid|fbclid|srsltid|msclkid|ttclid|_kx)$/;
    var qs = location.search.replace(/^\?/, '').split('&');
    for (var qi = 0; qi < qs.length; qi++) {
      var qk = qs[qi].split('=')[0];   /* not decoded: a stray % would make decodeURIComponent throw */
      if (qk && !okq.test(qk)) { wakeAll(); return; }
    }
    if (window.IntersectionObserver) {
      io = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) if (ents[i].isIntersecting) wake(ents[i].target);
      }, { rootMargin: '600px 0px', threshold: 0 });
      collect().forEach(function (el) { io.observe(el); });
    }
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, wakeAll, { once: true, passive: true, capture: true });
    });
    (window.requestIdleCallback || function (f) { setTimeout(f, 4000); })(wakeAll, { timeout: 4000 });
  }
  /* vendors.js assigns window.Alpine at parse time but defers Alpine.start() by a rAF (NZS-ALPINE-BOOT),
     so a live window.Alpine does NOT mean the boot walk has run -- waking a card before it lets
     Alpine.start() init that card a second time. */
  document.addEventListener('alpine:initialized', function () { window.__nzsAlpineUp = 1; start(); }, { once: true });
  if (window.__nzsAlpineUp) start();
})();
